// import React, { useEffect, useMemo, useState, useRef } from "react";
// import { jwtDecode } from "jwt-decode";
// import "./ChatBoard.css";
// import Navbar from "../common/Navbar";
// import Footer from "../common/Footer";
// import io from "socket.io-client";
// import Sideboard from "./Sideboard";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import EmojiPicker from "emoji-picker-react"; // Import the emoji picker
// import {
//   Box,
//   Typography,
//   InputBase,
//   Select,
//   MenuItem,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Card,
//   CardHeader,
//   CardContent,
//   CardActions,
//   Avatar,
// } from "@mui/material";
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const ChatBoard = () => {
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [userId, setUserId] = useState(null);
//   const [socket, setSocket] = useState(null);
//   const [receiverId, setReceiverId] = useState(null);
//   const [employees, setEmployees] = useState([]);
//   const [groups, setGroups] = useState([]);
//   const [showEmojiPicker, setShowEmojiPicker] = useState(false); // State for emoji picker visibility
//   const [files, setFiles] = useState([]); // New state for files
//   const [selectedFiles, setSelectedFiles] = useState([]); // Files selected for upload
//   const reactQuillRef = useRef(null); // Create a reference to the ReactQuill component

//   useEffect(() => {
//     const socketInstance = io();
//     setSocket(socketInstance);

//     socketInstance.on("newMessage", (messageData) => {
//       setMessages((prevMessages) => [...prevMessages, messageData.message]);
//     });

//     return () => {
//       if (socketInstance) socketInstance.disconnect();
//     };
//   }, []);

//   useEffect(() => {
//     const fetchEmployees = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         const response = await fetch(`/api/employees/`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) throw new Error("Error fetching employees");
//         const data = await response.json();
//         setEmployees(data);
//       } catch (err) {
//         console.error("Error fetching employees:", err);
//         setError("Error fetching employees");
//       }
//     };

//     const fetchGroups = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         const response = await fetch(`/api/chat/getallgroups`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) throw new Error("Error fetching groups");

//         const data = await response.json();
//         setGroups(Array.isArray(data.data) ? data.data : []);
//       } catch (err) {
//         console.error("Error fetching groups:", err);
//         setError("Error fetching groups");
//       }
//     };

//     fetchEmployees();
//     fetchGroups();
//   }, []);

//   const fetchMessages = async () => {
//     if (!receiverId) return;

//     setLoading(true);
//     const token = sessionStorage.getItem("token");
//     const decodedToken = jwtDecode(token);
//     const senderId = decodedToken.employee.id;

//     try {
//       const response = await fetch(
//         `/api/chat/getChat/${senderId}/${receiverId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) throw new Error("Error fetching messages");

//       const result = await response.json();

//       if (
//         result.status === 1 &&
//         result.data &&
//         Array.isArray(result.data.messages)
//       ) {
//         setMessages(result.data.messages);
//       } else {
//         setMessages([]);
//       }

//       setUserId(senderId);
//     } catch (err) {
//       console.error("Error fetching chat messages:", err);
//       setError("Error fetching chat messages");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchMessages();
//   }, [receiverId]);

//   const sendMessage = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const token = sessionStorage.getItem("token");

//     try {
//       const decodedToken = jwtDecode(token);
//       const senderId = decodedToken.employee.id;
//       const senderName = decodedToken.employee.name;

//       if (
//         !senderId ||
//         !receiverId ||
//         (!newMessage && selectedFiles.length === 0)
//       ) {
//         throw new Error(
//           "Sender ID, receiver ID, and either message or files are required"
//         );
//       }

//       const formData = new FormData();
//       formData.append("senderId", senderId);
//       formData.append("receiverId", receiverId);
//       formData.append("message", newMessage);

//       selectedFiles.forEach((file, index) => {
//         formData.append(`files`, file);
//       });

//       // Send the message to the backend
//       const response = await fetch(`/api/chat/sendMessage`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       if (!response.ok) throw new Error("Error sending message");

//       const newMsg = await response.json();

//       // Check if the message is successfully sent before updating the state
//       if (newMsg && newMsg.status === 1) {
//         setMessages((prevMessages) => [...prevMessages, newMsg.data]); // Only update with successful response
//       }

//       socket.emit("sendMessage", newMsg.data); // Emit the message via socket

//       setNewMessage(""); // Clear the message field
//       setSelectedFiles([]); // Clear selected files after sending
//     } catch (err) {
//       console.error("Error sending message:", err);
//       setError("Error sending message");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFileChange = (e) => {
//     setSelectedFiles(Array.from(e.target.files)); // Convert FileList to an array
//   };

//   const handleEmojiClick = (emoji) => {
//     // Get the current Quill editor instance
//     const quill = reactQuillRef.current.getEditor();

//     // Get the current cursor position
//     const cursorPosition = quill.getSelection()
//       ? quill.getSelection().index
//       : quill.getLength(); // Default to end of the message if no selection

//     // Insert the emoji after the current cursor position
//     quill.insertText(cursorPosition, emoji.emoji);

//     // Move the cursor to the position right after the inserted emoji
//     quill.setSelection(cursorPosition + emoji.emoji.length);

//     setShowEmojiPicker(false); // Close the emoji picker after selection
//   };

//   const formatTime = (timestamp) => {
//     if (!timestamp) return "Unknown time";
//     const date = new Date(timestamp);
//     return date.toLocaleString([], {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   return (
//     <>
//       <Navbar />
//             <Box sx={{mt:7 }}>
//       <div className="main-container">
//         <div className="sideboard-container">
//           <Sideboard
//             employees={employees}
//             groups={groups}
//             onSelectChat={setReceiverId}
//           />
//         </div>
//         <div className="chat-board-content">
//           <h2 className="chat-board-title">Chat Board</h2>

//           {loading && <p>Loading...</p>}
//           {error && <p>{error}</p>}

//           <div className="chat-messages">
//             {Array.isArray(messages) && messages.length > 0 ? (
//               messages
//                 .filter(
//                   (message) =>
//                     message.message ||
//                     (message.files && message.files.length > 0)
//                 )
//                 .map((message) => (
//                   <div
//                     key={message._id}
//                     className={`chat-message ${
//                       message.senderId === userId
//                         ? "my-message"
//                         : "other-message"
//                     }`}
//                   >
//                     <div
//                       className={`message-content-wrapper ${
//                         message.senderId === userId ? "right" : "left"
//                       }`}
//                     >
//                       <strong>{message.senderName}</strong>
//                       <div className="message-content">
//                         <p
//                           dangerouslySetInnerHTML={{ __html: message.message }}
//                         ></p>
//                         {message.files &&
//                           message.files.map((file, index) => {
//                             const fileType = file
//                               .split(".")
//                               .pop()
//                               .toLowerCase();
//                             const isImage = [
//                               "jpg",
//                               "jpeg",
//                               "png",
//                               "gif",
//                             ].includes(fileType);
//                             const isVideo = ["mp4", "webm", "ogg"].includes(
//                               fileType
//                             );
//                             const isPDF = fileType === "pdf";

//                             return (
//                               <div key={index} className="file-preview">
//                                 {isImage ? (
//                                   <img
//                                     src={file}
//                                     alt="uploaded"
//                                     className="chat-image"
//                                     onClick={() => window.open(file, "_blank")}
//                                   />
//                                 ) : isVideo ? (
//                                   <div
//                                     className="video-preview-container"
//                                     onClick={() => window.open(file, "_blank")}
//                                   >
//                                     <video
//                                       className="video-thumbnail"
//                                       preload="metadata"
//                                     >
//                                       <source
//                                         src={file}
//                                         type={`video/${fileType}`}
//                                       />
//                                       Your browser does not support the video
//                                       tag.
//                                     </video>
//                                     <div className="video-overlay">
//                                       <span className="play-button">▶</span>
//                                     </div>
//                                   </div>
//                                 ) : isPDF ? (
//                                   <a
//                                     href={file}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                   >
//                                     <button className="download-button">
//                                       View/Download PDF
//                                     </button>
//                                   </a>
//                                 ) : (
//                                   <a
//                                     href={file}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                   >
//                                     <button className="download-button">
//                                       Download {file.split("/").pop()}
//                                     </button>
//                                   </a>
//                                 )}
//                               </div>
//                             );
//                           })}
//                       </div>
//                       <div className="message-time">
//                         {formatTime(message.timestamp)}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//             ) : (
//               <p>No messages available</p>
//             )}
//           </div>

//           <form className="chat-input-form" onSubmit={sendMessage}>
//             <div className="emoji-picker-container">
//               <button
//                 type="button"
//                 className="emoji-direct-button"
//                 onClick={() => setShowEmojiPicker((prev) => !prev)}
//               >
//                 😀
//               </button>
//               {showEmojiPicker && (
//                 <EmojiPicker
//                   onEmojiClick={handleEmojiClick}
//                   pickerStyle={{
//                     position: "absolute",
//                     bottom: "50px",
//                     left: "10px",
//                   }}
//                 />
//               )}
//             </div>
//             <div>
//               <ReactQuill
//                 ref={reactQuillRef}
//                 value={newMessage}
//                 onChange={setNewMessage}
//                 placeholder="Type a message..."
//                 modules={{
//                   toolbar: [
//                     [{ header: "1" }, { header: "2" }, { font: [] }],
//                     [{ list: "ordered" }, { list: "bullet" }],
//                     ["bold", "italic", "underline"],
//                     ["link", "image"],
//                     ["blockquote"],
//                     ["code-block"],
//                   ],
//                 }}
//               />
//             </div>
//             <div className="file-input-container">
//               <input
//                 type="file"
//                 multiple
//                 onChange={handleFileChange}
//                 className="file-input"
//               />
//               {selectedFiles.length > 0 && (
//                 <div className="file-list">
//                   {selectedFiles.map((file, index) => (
//                     <div key={index} className="file-item">
//                       {file.name}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//             <button
//               type="submit"
//               disabled={loading || !newMessage}
//               className="send-button"
//             >
//               Send Message
//             </button>
//           </form>
//         </div>
//       </div>
//       </Box>
//       <Footer />
//     </>
//   );
// };

// export default ChatBoard;



///////////////////////////////////////////////////




















import React, { useEffect, useMemo, useState, useRef } from "react";
import { jwtDecode } from "jwt-decode";
import { marked } from "marked";
import { markedHighlight } from "marked-highlight";
import hljs from "highlight.js/lib/common";
import "highlight.js/styles/github.css";
import DOMPurify from "dompurify";
import { toast } from "react-toastify";
import Navbar from "../common/Navbar";
import SearchIcon from "@mui/icons-material/Search";

import TextField from "@mui/material/TextField";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import io from "socket.io-client";
import Sideboard from "./Sideboard";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EmojiPicker from "emoji-picker-react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Paper,
  Stack,
  Input,
  Avatar,

  InputBase,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Tooltip,
  Chip,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import SendIcon from "@mui/icons-material/Send";
import ChatIcon from "@mui/icons-material/Chat";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PublicIcon from "@mui/icons-material/Public";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PersonRemoveOutlinedIcon from "@mui/icons-material/PersonRemoveOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ReplyIcon from "@mui/icons-material/Reply";
import ShortcutOutlinedIcon from "@mui/icons-material/ShortcutOutlined";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import PushPinIcon from "@mui/icons-material/PushPin";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import ChatMediaLightbox, {
  collectChatMedia,
  mediaKind,
  fileNameFromUrl,
} from "./ChatMediaLightbox";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import StrikethroughSIcon from "@mui/icons-material/StrikethroughS";
import CodeIcon from "@mui/icons-material/Code";
import DataObjectIcon from "@mui/icons-material/DataObject";
import LinkIcon from "@mui/icons-material/Link";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { useNotifications } from "../../context/NotificationContext";

// All chat text is authored as Markdown (Mattermost-style). Old messages were
// composed in Quill and stored as HTML, so anything that already looks like
// markup is passed through as-is. Both paths end in DOMPurify — messages are
// rendered with dangerouslySetInnerHTML, so nothing may reach the DOM
// unsanitised (webhooks make this reachable by anyone who holds a hook URL).
marked.setOptions({ gfm: true, breaks: true });
// Fenced code blocks get Mattermost-style syntax colouring. hljs emits only
// spans with classes, which pass through DOMPurify untouched.
marked.use(
  markedHighlight({
    emptyLangClass: "hljs",
    langPrefix: "hljs language-",
    highlight(code, lang) {
      try {
        if (lang && hljs.getLanguage(lang)) return hljs.highlight(code, { language: lang }).value;
        return hljs.highlightAuto(code).value;
      } catch (_) {
        return code;
      }
    },
  })
);
if (typeof DOMPurify.addHook === "function" && !DOMPurify.__chatLinkHook) {
  DOMPurify.__chatLinkHook = true;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      const href = node.getAttribute("href") || "";
      if (/^https?:\/\//i.test(href)) {
        // External links: new tab, no opener.
        node.setAttribute("target", "_blank");
        node.setAttribute("rel", "noopener noreferrer");
      } else {
        // In-app links (Project Bot ticket links etc.): same tab.
        node.removeAttribute("target");
      }
    }
  });
}
const renderMessageHtml = (raw) => {
  const text = String(raw ?? "");
  if (!text) return "";
  const looksLikeHtml = /<\/?(p|div|br|span|strong|em|b|i|u|ul|ol|li|a|img|h[1-6]|blockquote|pre|code|table)\b/i.test(text);
  const html = looksLikeHtml ? text : marked.parse(text);
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
};

// Wrap "@Name" occurrences in styled spans (Mattermost-style). Runs on the
// ALREADY-SANITISED html and only inserts spans via textContent, so it cannot
// introduce markup. Skips pre/code/link subtrees so code samples stay intact.
const decorateMentions = (html, names, myName) => {
  if (!html || !names?.length || html.indexOf("@") === -1) return html;
  try {
    const doc = new DOMParser().parseFromString(`<div id="__mroot">${html}</div>`, "text/html");
    const root = doc.getElementById("__mroot");
    const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const sorted = [...new Set(names.filter(Boolean))].sort((a, b) => b.length - a.length);
    if (!sorted.length) return html;
    const re = new RegExp(`@(${sorted.map(esc).join("|")})`, "gi");
    const walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    const targets = [];
    let node;
    while ((node = walker.nextNode())) {
      const parent = node.parentElement;
      if (!parent || parent.closest("pre, code, a, .chat-mention")) continue;
      re.lastIndex = 0;
      if (re.test(node.nodeValue)) targets.push(node);
    }
    targets.forEach((textNode) => {
      const txt = textNode.nodeValue;
      const frag = doc.createDocumentFragment();
      let last = 0;
      re.lastIndex = 0;
      let m;
      while ((m = re.exec(txt))) {
        frag.appendChild(doc.createTextNode(txt.slice(last, m.index)));
        const span = doc.createElement("span");
        span.className = "chat-mention";
        if (myName && m[1].toLowerCase() === myName.toLowerCase()) span.setAttribute("data-me", "1");
        span.textContent = m[0];
        frag.appendChild(span);
        last = m.index + m[0].length;
      }
      frag.appendChild(doc.createTextNode(txt.slice(last)));
      textNode.parentNode.replaceChild(frag, textNode);
    });
    return root.innerHTML;
  } catch (_) {
    return html;
  }
};

const ChatBoard = () => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null);
  const [socket, setSocket] = useState(null);
  const [receiverId, setReceiverId] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [groups, setGroups] = useState([]);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  // Map of otherUserId -> last message time, used to float recently-active
  // direct messages to the top of the contact list.
  const [recentMap, setRecentMap] = useState({});
  // Per-conversation unread counts + last-message previews for the sidebar.
  const [unreadMap, setUnreadMap] = useState({ dm: {}, group: {} });
  const [previewMap, setPreviewMap] = useState({ dm: {}, group: {} });
  // "dm" for 1:1 direct messages, "group" for group chats.
  const [chatType, setChatType] = useState("dm");
  const chatTypeRef = useRef("dm");
  const [myRole, setMyRole] = useState("");
  const [createGroupOpen, setCreateGroupOpen] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [groupMembers, setGroupMembers] = useState([]);
  const [groupVisibility, setGroupVisibility] = useState("private");
  const [groupDescription, setGroupDescription] = useState("");
  // Reactions / edit / delete
  const [dmChatId, setDmChatId] = useState(null); // id of the open DM Chat doc
  const [editingId, setEditingId] = useState(null);
  const [editingText, setEditingText] = useState("");
  const [reactionPickerFor, setReactionPickerFor] = useState(null);
  const [hoverMsgId, setHoverMsgId] = useState(null);
  // Message search
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  // Browse-public-channels dialog
  const [browseOpen, setBrowseOpen] = useState(false);
  const [browseLoading, setBrowseLoading] = useState(false);
  const [publicChannels, setPublicChannels] = useState([]);
  const [joiningId, setJoiningId] = useState(null);
  // Channel settings dialog (members / visibility / webhooks / leave)
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsSaving, setSettingsSaving] = useState(false);
  const [editVisibility, setEditVisibility] = useState("private");
  const [editDescription, setEditDescription] = useState("");
  const [addMemberSel, setAddMemberSel] = useState([]);
  const [webhooks, setWebhooks] = useState([]);
  const [newWebhookName, setNewWebhookName] = useState("");
  // @mention composer state: null = picker closed, "" or "an" = filter query
  const [mentionQuery, setMentionQuery] = useState(null);
  const [mentionIndex, setMentionIndex] = useState(0);
  const composerInputRef = useRef(null);
  // name(lower) -> employee _id for mentions inserted via the picker
  const mentionDraftRef = useRef(new Map());
  // Socket handlers are registered once; they reach the latest reloadGroups here.
  const reloadGroupsRef = useRef(null);
  const reactQuillRef = useRef(null);
  const { clearChatUnread } = useNotifications();
  const myDisplayName = sessionStorage.getItem("name") || "";
  // ---- Presence / typing / custom status (Slack-style) ----
  const myEmpId = React.useMemo(() => {
    try { return jwtDecode(sessionStorage.getItem("token"))?.employee?.employeeid || null; } catch (_) { return null; }
  }, []);
  const [onlineSet, setOnlineSet] = useState(() => new Set());
  const [statuses, setStatuses] = useState({}); // employeeid -> { emoji, text }
  const [peerTyping, setPeerTyping] = useState(null); // { name } for the open chat
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [statusDraft, setStatusDraft] = useState({ emoji: "", text: "" });
  const [statusSaving, setStatusSaving] = useState(false);
  const lastTypingRef = useRef(0);
  const stopTypingTimerRef = useRef(null);
  const peerTypingTimerRef = useRef(null);
  // ---- Threaded replies + pinned messages ----
  const [replyingTo, setReplyingTo] = useState(null); // { _id, senderName, text }
  // ---- Forwarding ----
  const [forwardMsg, setForwardMsg] = useState(null); // the message object being forwarded
  const [forwardQuery, setForwardQuery] = useState("");
  const [forwardBusy, setForwardBusy] = useState(""); // target id with an in-flight forward
  const [highlightId, setHighlightId] = useState(null); // message briefly flashed after a thread jump
  const [pinnedOpen, setPinnedOpen] = useState(false);
  const [pinnedList, setPinnedList] = useState([]);
  const [mediaOpen, setMediaOpen] = useState(false);
  const [mediaList, setMediaList] = useState([]);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [lightbox, setLightbox] = useState(null); // { items, index }

  // Arriving on the chat page consumes the topbar unread-badge count.
  useEffect(() => {
    clearChatUnread();
  }, [clearChatUnread, receiverId]);

  // Let the global notifier (NotificationContext) know which conversation is
  // open, so @mention toasts still fire when a DIFFERENT channel is on screen.
  useEffect(() => {
    window.__openChatId = receiverId ? String(receiverId) : null;
    // Reset picker + drafted mentions when switching conversations.
    setMentionQuery(null);
    mentionDraftRef.current.clear();
    setPeerTyping(null);
    setLightbox(null);
    return () => {
      window.__openChatId = null;
    };
  }, [receiverId]);

  const canCreateGroup = ["admin", "hr", "manager"].includes(
    String(myRole).toLowerCase()
  );

  // Normalise a group message (content/createdAt + possibly populated sender)
  // into the same shape the renderer uses for direct messages.
  const normalizeGroupMessage = (m) => ({
    _id: String(m._id),
    senderId: m.senderId ? String(m.senderId?._id || m.senderId) : null,
    senderName:
      m.senderName ||
      m.senderId?.name ||
      (m.webhookName ? `${m.webhookName} (webhook)` : ""),
    isWebhook: !!m.webhookName && !m.senderId,
    isSystem: !!m.isSystem,
    message: m.content ?? m.message ?? "",
    files: m.files || [],
    timestamp: m.createdAt || m.timestamp,
    reactions: (m.reactions || []).map((r) => ({ employeeId: String(r.employeeId?._id || r.employeeId), emoji: r.emoji })),
    editedAt: m.editedAt || null,
    deletedAt: m.deletedAt || null,
    replyToMessageId: m.replyToMessageId ? String(m.replyToMessageId) : null,
    replyPreview: m.replyPreview || null,
    pinnedAt: m.pinnedAt || null,
    forwardedFrom: m.forwardedFrom?.senderName ? m.forwardedFrom : null,
  });

  // Patch a single message in place (reactions/edit/delete arrive via socket
  // or an optimistic local update).
  const patchMessage = (id, patch) => {
    setMessages((prev) => prev.map((m) => (String(m._id) === String(id) ? { ...m, ...patch } : m)));
  };

  const handleSelectChat = (id, type = "dm") => {
    setChatType(type);
    chatTypeRef.current = type;
    setReceiverId(id);
    persistRead(type === "group" ? "group" : "dm", id);
  };

  const incUnread = (scope, id, preview) => {
    const key = String(id);
    setUnreadMap((prev) => ({
      ...prev,
      [scope]: { ...prev[scope], [key]: (prev[scope]?.[key] || 0) + 1 },
    }));
    if (preview) {
      setPreviewMap((prev) => ({
        ...prev,
        [scope]: { ...prev[scope], [key]: preview },
      }));
    }
  };

  const zeroUnread = (scope, id) => {
    setUnreadMap((prev) => ({
      ...prev,
      [scope]: { ...prev[scope], [String(id)]: 0 },
    }));
  };

  const persistRead = (scope, conversationId) => {
    if (!conversationId) return;
    zeroUnread(scope, conversationId);
    const token = sessionStorage.getItem("token");
    if (!token) return;
    fetch(`/api/chat/mark-read`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      body: JSON.stringify({ scope, conversationId: String(conversationId) }),
    }).catch(() => {});
  };
  const persistReadRef = useRef(persistRead);
  persistReadRef.current = persistRead;
  const incUnreadRef = useRef(incUnread);
  incUnreadRef.current = incUnread;

  const sidebarPreview = (raw, files) => {
    const t = String(raw || "")
      .replace(/<[^>]+>/g, " ")
      .replace(/[#*_`>]/g, "")
      .replace(/\s+/g, " ")
      .trim();
    if (t) return t.slice(0, 80);
    if (files && files.length) return "📎 Attachment";
    return "";
  };

  const bumpRecent = (otherId, at) => {
    if (!otherId) return;
    setRecentMap((prev) => ({
      ...prev,
      [String(otherId)]: at ? new Date(at).toISOString() : new Date().toISOString(),
    }));
  };

  // Keep the latest selected chat + my id available inside the socket handler
  // (which is registered once and would otherwise capture stale values).
  const receiverIdRef = useRef(null);
  const userIdRef = useRef(null);

  // Resolve my own identity from the token up-front so message alignment and
  // self-filtering work even before a conversation is opened.
  useEffect(() => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) return;
      const decoded = jwtDecode(token);
      const myId = decoded?.employee?.id || decoded?.employee?._id || null;
      setUserId(myId);
      userIdRef.current = myId;
      setMyRole(decoded?.employee?.role || "");
    } catch (_) {}
  }, []);

  // Load persisted custom statuses so peers' statuses render immediately.
  useEffect(() => {
    (async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) return;
        const res = await fetch(`/api/chat/statuses`, { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) return;
        const json = await res.json();
        const map = {};
        (json.data || []).forEach((s) => { map[String(s.employeeid)] = { emoji: s.emoji || "", text: s.text || "" }; });
        setStatuses(map);
      } catch (_) {}
    })();
  }, []);

  // Emit typing to the open conversation (throttled); auto-stop after idle.
  const emitTyping = () => {
    if (!socket || !receiverId) return;
    let base;
    if (chatType === "group") {
      base = { scope: "group", groupId: String(receiverId), fromUserId: userId, fromName: myDisplayName };
    } else {
      const peer = employees.find((e) => String(e._id) === String(receiverId));
      if (!peer?.employeeid) return;
      base = { scope: "dm", toEmpId: peer.employeeid, fromUserId: userId, fromName: myDisplayName };
    }
    const now = Date.now();
    if (now - lastTypingRef.current > 2000) { socket.emit("typing", base); lastTypingRef.current = now; }
    clearTimeout(stopTypingTimerRef.current);
    stopTypingTimerRef.current = setTimeout(() => { socket.emit("stop_typing", base); lastTypingRef.current = 0; }, 2500);
  };
  const stopTypingNow = () => {
    if (!socket || !receiverId) return;
    clearTimeout(stopTypingTimerRef.current);
    let base;
    if (chatType === "group") base = { scope: "group", groupId: String(receiverId), fromUserId: userId };
    else {
      const peer = employees.find((e) => String(e._id) === String(receiverId));
      if (!peer?.employeeid) return;
      base = { scope: "dm", toEmpId: peer.employeeid, fromUserId: userId };
    }
    socket.emit("stop_typing", base);
    lastTypingRef.current = 0;
  };

  // Save my custom status (Slack-style emoji + text).
  const saveStatus = async () => {
    setStatusSaving(true);
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`/api/chat/status`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ emoji: statusDraft.emoji || "", text: statusDraft.text || "" }),
      });
      if (!res.ok) throw new Error("Failed to save status");
      if (myEmpId) setStatuses((prev) => ({ ...prev, [String(myEmpId)]: { emoji: statusDraft.emoji || "", text: statusDraft.text || "" } }));
      setStatusDialogOpen(false);
      toast.success("Status updated");
    } catch (err) {
      toast.error(err.message || "Could not update status");
    } finally { setStatusSaving(false); }
  };

  // ---- Reply + Pin helpers ----
  const msgById = (id) => messages.find((m) => String(m._id) === String(id));

  // Thread navigation: how many replies each message has, + jump-to/highlight.
  const replyCounts = useMemo(() => {
    const c = {};
    messages.forEach((m) => { if (m.replyToMessageId && !m.deletedAt) c[String(m.replyToMessageId)] = (c[String(m.replyToMessageId)] || 0) + 1; });
    return c;
  }, [messages]);
  const firstReplyId = (id) => {
    const r = messages.find((m) => String(m.replyToMessageId) === String(id) && !m.deletedAt);
    return r ? String(r._id) : null;
  };
  const scrollToMessage = (id) => {
    if (!id) return;
    const box = messagesBoxRef.current;
    const el = box?.querySelector(`[data-mid="${id}"]`);
    if (!box || !el) { toast.info("That message isn't loaded here"); return; }
    const boxRect = box.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    box.scrollTo({ top: box.scrollTop + (elRect.top - boxRect.top) - box.clientHeight / 2 + elRect.height / 2, behavior: "smooth" });
    setHighlightId(String(id));
    setTimeout(() => setHighlightId((h) => (h === String(id) ? null : h)), 1600);
  };

  const startReply = (m) => {
    const text = (m.message || m.content || "").replace(/[#*_`>]/g, "").slice(0, 140);
    const mine = String(m.senderId) === String(userId);
    setReplyingTo({ _id: String(m._id), senderName: mine ? "yourself" : (m.senderName || "them"), text });
    setTimeout(() => composerInputRef.current?.focus?.(), 0);
  };

  // Forward a message (text + attachments) to another DM or channel. Reuses
  // the normal send endpoints; attachments travel as existingFiles URLs so
  // nothing is re-uploaded.
  const forwardTo = async (target) => {
    const m = forwardMsg;
    if (!m) return;
    setForwardBusy(target.id);
    try {
      const token = sessionStorage.getItem("token");
      const mine = String(m.senderId) === String(userId);
      const originName = mine ? "you" : (m.senderName || employees.find((e) => String(e._id) === String(m.senderId))?.name || "Unknown");
      const fd = new FormData();
      const text = m.message || m.content || "";
      const files = m.files || [];
      if (files.length) fd.append("existingFiles", JSON.stringify(files));
      fd.append("forwardedFrom", JSON.stringify({ senderName: originName, sourceType: chatType === "group" ? "group" : "dm" }));
      let url;
      if (target.type === "group") {
        fd.append("groupId", target.id);
        fd.append("content", text);
        url = "/api/chat/sendMessageingroup";
      } else {
        fd.append("receiverId", target.id);
        fd.append("message", text);
        url = "/api/chat/sendMessage";
      }
      const res = await fetch(url, { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: fd });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || json.status !== 1) throw new Error(json.message || "Could not forward");
      // If forwarding into the conversation currently on screen, show it now.
      if (String(target.id) === String(receiverId) && target.type === chatType) {
        const sent = target.type === "group" ? normalizeGroupMessage(json.data) : json.data?.message;
        if (sent) setMessages((prev) => (prev.some((x) => String(x._id) === String(sent._id)) ? prev : [...prev, sent]));
      }
      bumpRecent(target.id, new Date().toISOString());
      toast.success(`Forwarded to ${target.name}`);
      setForwardMsg(null);
      setForwardQuery("");
    } catch (err) {
      toast.error(err.message || "Could not forward");
    } finally {
      setForwardBusy("");
    }
  };

  const togglePin = async (m) => {
    try {
      const token = sessionStorage.getItem("token");
      const body = chatType === "group"
        ? { scope: "group", messageId: String(m._id) }
        : { scope: "dm", chatId: dmChatId, messageId: String(m._id) };
      const res = await fetch(`/api/chat/pin`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const json = await res.json();
      if (!res.ok || json.status !== 1) throw new Error(json.message || "Could not pin");
      patchMessage(m._id, { pinnedAt: json.data.pinnedAt });
      toast.success(json.data.pinnedAt ? "📌 Pinned" : "Unpinned");
    } catch (err) { toast.error(err.message); }
  };

  const openPinned = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const qs = chatType === "group" ? `scope=group&groupId=${receiverId}` : `scope=dm&chatId=${dmChatId}`;
      const res = await fetch(`/api/chat/pinned?${qs}`, { headers: { Authorization: `Bearer ${token}` } });
      const json = await res.json();
      setPinnedList(json.data || []);
      setPinnedOpen(true);
    } catch (err) { toast.error("Could not load pinned messages"); }
  };

  const openMedia = async () => {
    setMediaOpen(true);
    setMediaLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const qs = chatType === "group" ? `scope=group&groupId=${receiverId}` : `scope=dm&chatId=${dmChatId}`;
      const res = await fetch(`/api/chat/media?${qs}`, { headers: { Authorization: `Bearer ${token}` } });
      const json = await res.json();
      setMediaList(json.data || []);
    } catch (err) { toast.error("Could not load media"); }
    finally { setMediaLoading(false); }
  };

  const openMediaLightbox = (url, itemsOverride) => {
    const fromChat = collectChatMedia(messages);
    const items = itemsOverride?.length ? itemsOverride : fromChat;
    let index = items.findIndex((i) => i.url === url);
    let list = items;
    if (index < 0) {
      const kind = mediaKind(url);
      if (!kind) return;
      list = [{ url, kind, name: fileNameFromUrl(url) }, ...items];
      index = 0;
    }
    setLightbox({ items: list, index });
  };

  const handleMessageHtmlClick = (e) => {
    const img = e.target.closest?.("img");
    const anchor = e.target.closest?.("a");
    const url = img?.getAttribute("src") || anchor?.getAttribute("href");
    if (!url || !mediaKind(url)) return;
    e.preventDefault();
    e.stopPropagation();
    openMediaLightbox(url);
  };

  useEffect(() => {
    receiverIdRef.current = receiverId;
  }, [receiverId]);
  useEffect(() => {
    userIdRef.current = userId;
  }, [userId]);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) return;

    // The backend socket layer requires a valid JWT in the handshake, so we
    // must pass the token (bare io() was being rejected → no realtime at all).
    // forceNew gives ChatBoard its own dedicated connection instead of sharing
    // (multiplexing) the one created by NotificationContext — otherwise this
    // component's cleanup/disconnect would tear down the shared socket and
    // realtime delivery would silently stop until a page refresh.
    const socketInstance = io({
      auth: { token },
      query: { token },
      // Polling first, then upgrade — socket.io's default handshake. Forcing
      // websocket-first silently killed ALL realtime wherever the ws upgrade
      // can't pass (CRA dev proxy, some reverse-proxy hops): v4 keeps retrying
      // the first listed transport instead of falling back to polling.
      transports: ["polling", "websocket"],
      reconnection: true,
      forceNew: true,
    });
    setSocket(socketInstance);

    // Join my personal room so 1:1 messages are delivered to me specifically.
    // Re-join on every (re)connect so reconnections don't drop the room.
    let myEmpKey = null;
    try {
      myEmpKey = jwtDecode(token)?.employee?.employeeid || null;
    } catch (_) {}
    const joinRoom = () => {
      if (myEmpKey) socketInstance.emit("join_user", myEmpKey);
    };
    socketInstance.on("connect", joinRoom);
    if (socketInstance.connected) joinRoom();

    socketInstance.on("newMessage", ({ message } = {}) => {
      if (!message) return;
      const myId = userIdRef.current;
      const openId = receiverIdRef.current;
      // Float this conversation to the top of Direct Messages regardless of
      // whether it's the one currently open.
      const otherId = String(message.senderId) === String(myId) ? message.receiverId : message.senderId;
      bumpRecent(otherId, message.timestamp);
      const preview = sidebarPreview(message.message, message.files);
      if (preview) {
        setPreviewMap((prev) => ({
          ...prev,
          dm: { ...prev.dm, [String(otherId)]: preview },
        }));
      }
      // Only append messages that belong to the conversation currently open.
      const belongsToOpenChat =
        chatTypeRef.current === "dm" &&
        ((String(message.senderId) === String(openId) && String(message.receiverId) === String(myId)) ||
          (String(message.senderId) === String(myId) && String(message.receiverId) === String(openId)));
      if (belongsToOpenChat) {
        setMessages((prev) => {
          if (prev.some((m) => String(m._id) === String(message._id))) return prev;
          return [...prev, message];
        });
        if (String(message.senderId) !== String(myId)) {
          persistReadRef.current?.("dm", openId);
        }
        return;
      }
      if (String(message.senderId) !== String(myId)) {
        incUnreadRef.current?.("dm", otherId, preview);
      }
    });

    socketInstance.on("newGroupMessage", ({ groupId, message } = {}) => {
      if (!message || !groupId) return;
      // Float this group to the top of the list.
      bumpRecent(groupId, message.createdAt || message.timestamp);
      const preview = sidebarPreview(message.content || message.message, message.files);
      if (preview) {
        setPreviewMap((prev) => ({
          ...prev,
          group: { ...prev.group, [String(groupId)]: preview },
        }));
      }
      // Append only if this group chat is the one currently open.
      if (chatTypeRef.current === "group" && String(receiverIdRef.current) === String(groupId)) {
        const norm = normalizeGroupMessage(message);
        setMessages((prev) => {
          if (prev.some((m) => String(m._id) === String(norm._id))) return prev;
          return [...prev, norm];
        });
        if (message.senderId && String(message.senderId) !== String(userIdRef.current) && !message.isSystem) {
          persistReadRef.current?.("group", groupId);
        }
        return;
      }
      if (!message.isSystem && String(message.senderId || "") !== String(userIdRef.current || "")) {
        incUnreadRef.current?.("group", groupId, preview);
      }
    });

    // Live reaction / edit / delete for the message currently in view.
    const applyPatch = (id, patch) =>
      setMessages((prev) => prev.map((m) => (String(m._id) === String(id) ? { ...m, ...patch } : m)));
    socketInstance.on("messageUpdated", ({ message } = {}) => {
      if (!message?._id) return;
      applyPatch(message._id, {
        reactions: message.reactions || [],
        editedAt: message.editedAt || null,
        deletedAt: message.deletedAt || null,
        ...(message.message != null ? { message: message.message } : {}),
        ...(message.pinnedAt !== undefined ? { pinnedAt: message.pinnedAt } : {}),
      });
    });
    socketInstance.on("groupMessageUpdated", ({ groupId, message } = {}) => {
      if (!message?._id) return;
      if (chatTypeRef.current !== "group" || String(receiverIdRef.current) !== String(groupId)) return;
      applyPatch(message._id, {
        reactions: message.reactions || [],
        editedAt: message.editedAt || null,
        deletedAt: message.deletedAt || null,
        ...(message.content != null ? { message: message.content } : {}),
      });
    });

    // I was added to / removed from a channel: refresh the sidebar live and,
    // if the channel I'm looking at was just taken away, drop back to the list.
    socketInstance.on("group_membership_changed", ({ groupId, groupName, action } = {}) => {
      reloadGroupsRef.current?.();
      if (action === "added") {
        toast.info(`You were added to #${groupName || "a channel"}`);
      } else if (action === "removed") {
        toast.info(`You were removed from #${groupName || "a channel"}`);
        if (chatTypeRef.current === "group" && String(receiverIdRef.current) === String(groupId)) {
          setReceiverId(null);
        }
      }
    });

    // Presence + custom status + typing (Slack-parity).
    socketInstance.on("presence_state", (ids) => setOnlineSet(new Set((ids || []).map(String))));
    socketInstance.on("presence_update", ({ employeeid, online } = {}) => {
      if (!employeeid) return;
      setOnlineSet((prev) => {
        const n = new Set(prev);
        if (online) n.add(String(employeeid)); else n.delete(String(employeeid));
        return n;
      });
    });
    socketInstance.on("status_update", ({ employeeid, emoji, text } = {}) => {
      if (!employeeid) return;
      setStatuses((prev) => ({ ...prev, [String(employeeid)]: { emoji: emoji || "", text: text || "" } }));
    });
    socketInstance.on("peer_typing", (p = {}) => {
      const openId = receiverIdRef.current;
      const dmMatch = p.scope === "dm" && String(p.fromUserId) === String(openId);
      const grpMatch = p.scope === "group" && chatTypeRef.current === "group" && String(p.groupId) === String(openId);
      if (!dmMatch && !grpMatch) return;
      setPeerTyping({ name: p.fromName || "Someone" });
      clearTimeout(peerTypingTimerRef.current);
      peerTypingTimerRef.current = setTimeout(() => setPeerTyping(null), 4500);
    });
    socketInstance.on("peer_stop_typing", (p = {}) => {
      const openId = receiverIdRef.current;
      if ((p.scope === "dm" && String(p.fromUserId) === String(openId)) ||
          (p.scope === "group" && String(p.groupId) === String(openId))) {
        setPeerTyping(null);
      }
    });

    return () => {
      if (socketInstance) socketInstance.disconnect();
    };
  }, []);

  // Join a socket room for every group I belong to, so group messages are
  // delivered live. Re-runs when my groups list or the socket changes.
  useEffect(() => {
    if (!socket || !groups.length) return;
    const joinGroups = () => groups.forEach((g) => g?._id && socket.emit("join_group", String(g._id)));
    joinGroups();
    socket.on("connect", joinGroups);
    return () => socket.off("connect", joinGroups);
  }, [socket, groups]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = sessionStorage.getItem("token");
        // Use the company directory (available to every authenticated user)
        // instead of the admin-only /api/employees roster, so managers and
        // employees also get a contact list to chat with.
        const res = await fetch(`/api/self-service/directory?includeBots=1`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Error fetching employees");
        const json = await res.json();
        const list = Array.isArray(json) ? json : json?.data || [];
        let myId = null;
        try {
          myId = jwtDecode(token)?.employee?.id || jwtDecode(token)?.employee?._id;
        } catch (_) {}
        // Don't list myself as a contact.
        setEmployees(list.filter((e) => String(e._id) !== String(myId)));
      } catch (err) {
        setError("Error fetching employees");
      }
    };

    const ingestGroups = (list) => {
      setGroups(list);
      setUnreadMap((prev) => {
        const group = { ...prev.group };
        list.forEach((g) => {
          if (g?._id && g.unreadCount != null) group[String(g._id)] = g.unreadCount;
        });
        return { ...prev, group };
      });
      setPreviewMap((prev) => {
        const group = { ...prev.group };
        list.forEach((g) => {
          if (g?._id && g.lastMessage) group[String(g._id)] = g.lastMessage;
        });
        return { ...prev, group };
      });
      setRecentMap((prev) => {
        const next = { ...prev };
        list.forEach((g) => {
          if (g?._id && g.lastMessageAt) next[String(g._id)] = g.lastMessageAt;
        });
        return next;
      });
    };

    const fetchGroups = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const res = await fetch(`/api/chat/getallgroups`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Error fetching groups");
        const data = await res.json();
        ingestGroups(Array.isArray(data.data) ? data.data : []);
      } catch (err) {
        setError("Error fetching groups");
      }
    };

    // Seed the recent-activity map so existing conversations are pre-sorted
    // (most recent first) on load, plus persisted unread badges.
    const fetchConversations = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const res = await fetch(`/api/chat/conversations`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const json = await res.json();
        const list = Array.isArray(json?.data) ? json.data : [];
        const map = {};
        const dmUnread = {};
        const dmPreview = {};
        list.forEach((c) => {
          if (c.otherId && c.lastMessageAt) map[String(c.otherId)] = c.lastMessageAt;
          if (c.otherId) dmUnread[String(c.otherId)] = c.unreadCount || 0;
          if (c.otherId && c.lastMessage) dmPreview[String(c.otherId)] = c.lastMessage;
        });
        setRecentMap((prev) => ({ ...prev, ...map }));
        setUnreadMap((prev) => ({ ...prev, dm: { ...prev.dm, ...dmUnread } }));
        setPreviewMap((prev) => ({ ...prev, dm: { ...prev.dm, ...dmPreview } }));
      } catch (_) {}
    };

    fetchEmployees();
    fetchGroups();
    fetchConversations();
  }, []);

  const fetchMessages = async () => {
    if (!receiverId) return;
    setLoading(true);

    try {
      const token = sessionStorage.getItem("token");
      const decoded = jwtDecode(token);
      const senderId = decoded.employee.id;
      setUserId(senderId);

      if (chatType === "group") {
        const res = await fetch(`/api/chat/groupmessages/${receiverId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Error fetching messages");
        const result = await res.json();
        const list = Array.isArray(result?.data) ? result.data : [];
        setMessages(list.map(normalizeGroupMessage));
        setError(null);
        return;
      }

      const res = await fetch(
        `/api/chat/getChat/${senderId}/${receiverId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // 404 = no conversation yet → treat as empty, not an error
      if (res.status === 404) {
        setMessages([]);
        setError(null);
        return;
      }
      if (!res.ok) throw new Error("Error fetching messages");
      const result = await res.json();
      setMessages(result?.data?.messages || []);
      setDmChatId(result?.data?._id || null);
      setError(null);
    } catch (err) {
      setError("Error fetching chat messages");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receiverId, chatType]);

  const sendMessage = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = sessionStorage.getItem("token");

    try {
      const decoded = jwtDecode(token);
      const senderId = decoded.employee.id;

      if (!senderId || !receiverId || (!newMessage && selectedFiles.length === 0)) {
        throw new Error("Message or files required");
      }

      const formData = new FormData();
      selectedFiles.forEach((f) => formData.append("files", f));

      if (chatType === "group") {
        formData.append("groupId", receiverId);
        formData.append("content", newMessage);
        if (replyingTo?._id) formData.append("replyToMessageId", replyingTo._id);
        // Who to ping with the louder mention notification.
        const mentionIds = collectMentionIds(newMessage);
        if (mentionIds.length) formData.append("mentions", JSON.stringify(mentionIds));
        const res = await fetch(`/api/chat/sendMessageingroup`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        });
        if (!res.ok) throw new Error("Error sending message");
        const data = await res.json();
        const sent = data?.data;
        if (data?.status === 1 && sent) {
          const norm = normalizeGroupMessage(sent);
          setMessages((prev) =>
            prev.some((m) => String(m._id) === String(norm._id)) ? prev : [...prev, norm]
          );
          bumpRecent(receiverId, norm.timestamp);
        }
      } else {
        formData.append("senderId", senderId);
        formData.append("receiverId", receiverId);
        formData.append("message", newMessage);
        if (replyingTo?._id) formData.append("replyToMessageId", replyingTo._id);
        const res = await fetch(`/api/chat/sendMessage`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        });
        if (!res.ok) throw new Error("Error sending message");
        const data = await res.json();
        // Backend returns { chatId, message }. Append the message (deduped — the
        // socket may echo the same one back to us since we're in our own room).
        const sent = data?.data?.message;
        if (data?.data?.chatId) setDmChatId(data.data.chatId);
        if (data?.status === 1 && sent) {
          setMessages((prev) =>
            prev.some((m) => String(m._id) === String(sent._id)) ? prev : [...prev, sent]
          );
          bumpRecent(receiverId, sent.timestamp);
        }
      }

      setNewMessage("");
      setSelectedFiles([]);
      mentionDraftRef.current.clear();
      setMentionQuery(null);
      setError(null);
      setReplyingTo(null);
      stopTypingNow();
    } catch (err) {
      setError("Error sending message");
    } finally {
      setLoading(false);
    }
  };

  const reloadGroups = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`/api/chat/getallgroups`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return;
      const data = await res.json();
      const list = Array.isArray(data.data) ? data.data : [];
      setGroups(list);
      setUnreadMap((prev) => {
        const group = { ...prev.group };
        list.forEach((g) => {
          if (g?._id && g.unreadCount != null) group[String(g._id)] = g.unreadCount;
        });
        return { ...prev, group };
      });
      setPreviewMap((prev) => {
        const group = { ...prev.group };
        list.forEach((g) => {
          if (g?._id && g.lastMessage) group[String(g._id)] = g.lastMessage;
        });
        return { ...prev, group };
      });
      setRecentMap((prev) => {
        const next = { ...prev };
        list.forEach((g) => {
          if (g?._id && g.lastMessageAt) next[String(g._id)] = g.lastMessageAt;
        });
        return next;
      });
    } catch (_) {}
  };
  reloadGroupsRef.current = reloadGroups;

  const handleCreateGroup = async () => {
    const name = groupName.trim();
    if (!name || groupMembers.length === 0) {
      setError("Group name and at least one member are required");
      return;
    }
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`/api/chat/creategroup`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          members: groupMembers.map((m) => m._id),
          visibility: groupVisibility,
          description: groupDescription.trim(),
        }),
      });
      const data = await res.json();
      if (!res.ok || data?.status !== 1) {
        throw new Error(data?.message || "Error creating group");
      }
      setCreateGroupOpen(false);
      setGroupName("");
      setGroupMembers([]);
      setGroupVisibility("private");
      setGroupDescription("");
      setError(null);
      await reloadGroups();
      // Open the newly-created group.
      if (data?.data?._id) handleSelectChat(data.data._id, "group");
    } catch (err) {
      setError(err.message || "Error creating group");
    }
  };

  // ---- Channel management (Mattermost-style) ----

  const authHeaders = () => ({
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    "Content-Type": "application/json",
  });

  const activeGroup = React.useMemo(
    () => groups.find((g) => String(g._id) === String(receiverId)) || null,
    [groups, receiverId]
  );
  const isChannelAdmin =
    !!activeGroup && String(activeGroup.adminId) === String(userId);
  // In a channel, the channel admin (or an app admin/hr) can delete anyone's
  // message; in DMs only your own (handled by the isMe check).
  const canDeleteAny =
    chatType === "group" && (isChannelAdmin || ["admin", "hr"].includes(String(myRole).toLowerCase()));

  const openBrowseChannels = async () => {
    setBrowseOpen(true);
    setBrowseLoading(true);
    try {
      const res = await fetch(`/api/chat/groups/public`, { headers: authHeaders() });
      const data = await res.json();
      setPublicChannels(Array.isArray(data?.data) ? data.data : []);
    } catch (_) {
      toast.error("Could not load public channels");
    } finally {
      setBrowseLoading(false);
    }
  };

  const handleJoinChannel = async (channelId) => {
    setJoiningId(channelId);
    try {
      const res = await fetch(`/api/chat/groups/${channelId}/join`, {
        method: "POST",
        headers: authHeaders(),
      });
      const data = await res.json();
      if (!res.ok || data?.status !== 1) throw new Error(data?.message || "Could not join channel");
      toast.success("Joined channel");
      await reloadGroups();
      setBrowseOpen(false);
      handleSelectChat(channelId, "group");
    } catch (err) {
      toast.error(err.message || "Could not join channel");
    } finally {
      setJoiningId(null);
    }
  };

  const openChannelSettings = async () => {
    if (!activeGroup) return;
    setEditVisibility(activeGroup.visibility === "public" ? "public" : "private");
    setEditDescription(activeGroup.description || "");
    setAddMemberSel([]);
    setNewWebhookName("");
    setWebhooks([]);
    setSettingsOpen(true);
    if (String(activeGroup.adminId) === String(userId)) {
      try {
        const res = await fetch(`/api/chat/groups/${activeGroup._id}/webhooks`, { headers: authHeaders() });
        const data = await res.json();
        if (res.ok && data?.status === 1) setWebhooks(Array.isArray(data.data) ? data.data : []);
      } catch (_) {}
    }
  };

  const handleSaveChannelSettings = async () => {
    if (!activeGroup) return;
    setSettingsSaving(true);
    try {
      const res = await fetch(`/api/chat/groups/${activeGroup._id}`, {
        method: "PATCH",
        headers: authHeaders(),
        body: JSON.stringify({ visibility: editVisibility, description: editDescription.trim() }),
      });
      const data = await res.json();
      if (!res.ok || data?.status !== 1) throw new Error(data?.message || data?.msg || "Could not update channel");
      toast.success("Channel updated");
      await reloadGroups();
    } catch (err) {
      toast.error(err.message || "Could not update channel");
    } finally {
      setSettingsSaving(false);
    }
  };

  const handleAddMembers = async () => {
    if (!activeGroup || addMemberSel.length === 0) return;
    try {
      const res = await fetch(`/api/chat/groups/${activeGroup._id}/members/add`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({ memberIds: addMemberSel.map((m) => m._id) }),
      });
      const data = await res.json();
      if (!res.ok || data?.status !== 1) throw new Error(data?.message || data?.msg || "Could not add members");
      toast.success(addMemberSel.length === 1 ? "Member added" : `${addMemberSel.length} members added`);
      setAddMemberSel([]);
      await reloadGroups();
    } catch (err) {
      toast.error(err.message || "Could not add members");
    }
  };

  const handleRemoveMember = async (memberId) => {
    if (!activeGroup) return;
    try {
      const res = await fetch(`/api/chat/groups/${activeGroup._id}/members/remove`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({ memberIds: [memberId] }),
      });
      const data = await res.json();
      if (!res.ok || data?.status !== 1) throw new Error(data?.message || data?.msg || "Could not remove member");
      toast.success("Member removed");
      await reloadGroups();
    } catch (err) {
      toast.error(err.message || "Could not remove member");
    }
  };

  const handleLeaveChannel = async () => {
    if (!activeGroup) return;
    try {
      const res = await fetch(`/api/chat/groups/${activeGroup._id}/leave`, {
        method: "POST",
        headers: authHeaders(),
      });
      const data = await res.json();
      if (!res.ok || data?.status !== 1) throw new Error(data?.message || "Could not leave channel");
      toast.success("Left channel");
      setSettingsOpen(false);
      setReceiverId(null);
      await reloadGroups();
    } catch (err) {
      toast.error(err.message || "Could not leave channel");
    }
  };

  const handleCreateWebhook = async () => {
    const name = newWebhookName.trim();
    if (!activeGroup || !name) return;
    try {
      const res = await fetch(`/api/chat/groups/${activeGroup._id}/webhooks`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({ name }),
      });
      const data = await res.json();
      if (!res.ok || data?.status !== 1) throw new Error(data?.message || "Could not create webhook");
      setWebhooks((prev) => [...prev, data.data]);
      setNewWebhookName("");
      toast.success("Webhook created — copy its URL below");
    } catch (err) {
      toast.error(err.message || "Could not create webhook");
    }
  };

  const handleRevokeWebhook = async (token) => {
    if (!activeGroup) return;
    try {
      const res = await fetch(`/api/chat/groups/${activeGroup._id}/webhooks/${token}`, {
        method: "DELETE",
        headers: authHeaders(),
      });
      const data = await res.json();
      if (!res.ok || data?.status !== 1) throw new Error(data?.message || "Could not revoke webhook");
      setWebhooks((prev) => prev.filter((w) => w.token !== token));
      toast.success("Webhook revoked");
    } catch (err) {
      toast.error(err.message || "Could not revoke webhook");
    }
  };

  const webhookUrl = (w) => `${window.location.origin}${w.path || `/api/chat/webhook/${w.token}`}`;

  const copyWebhookUrl = (w) => {
    navigator.clipboard?.writeText(webhookUrl(w));
    toast.success("Webhook URL copied");
  };

  // Members of the open channel, resolved against the directory (which the
  // page already loads). The directory excludes me, so add myself explicitly.
  const channelMembers = React.useMemo(() => {
    if (!activeGroup) return [];
    const byId = new Map(employees.map((e) => [String(e._id), e]));
    return (activeGroup.members || []).map((id) => {
      const key = String(id?._id || id);
      if (key === String(userId)) return { _id: key, name: "You", isMe: true };
      const emp = byId.get(key);
      return { _id: key, name: emp?.name || "Unknown member", designation: emp?.designation };
    });
  }, [activeGroup, employees, userId]);

  // People only (bots list in DMs but can't be channel members / forward targets).
  const humanEmployees = React.useMemo(
    () => employees.filter((e) => !String(e.employeeid || "").startsWith("BOT-")),
    [employees]
  );

  const nonMemberEmployees = React.useMemo(() => {
    if (!activeGroup) return humanEmployees;
    const memberIds = new Set((activeGroup.members || []).map((id) => String(id?._id || id)));
    return humanEmployees.filter((e) => !memberIds.has(String(e._id)));
  }, [activeGroup, humanEmployees]);

  // ---- @mentions ----

  // People who can be @-picked in the current conversation.
  const mentionPool = React.useMemo(() => {
    if (chatType === "group") {
      const members = channelMembers.filter((m) => !m.isMe && m.name !== "Unknown member");
      // Broadcast pseudo-mentions — the backend detects @channel/@here from the
      // message text; their placeholder ids are filtered out server-side.
      return [
        { _id: "__channel__", name: "channel", designation: "Notify everyone in this channel" },
        { _id: "__here__", name: "here", designation: "Notify online members" },
        ...members,
      ];
    }
    const partner = employees.find((e) => String(e._id) === String(receiverId));
    return partner ? [partner] : [];
  }, [chatType, channelMembers, employees, receiverId]);

  const mentionCandidates = React.useMemo(() => {
    if (mentionQuery == null) return [];
    const q = mentionQuery.toLowerCase();
    return mentionPool.filter((p) => (p.name || "").toLowerCase().includes(q)).slice(0, 6);
  }, [mentionQuery, mentionPool]);

  // Names that should light up inside rendered bubbles.
  const mentionNames = React.useMemo(() => {
    const names = mentionPool.map((p) => p.name);
    if (myDisplayName) names.push(myDisplayName);
    if (chatType === "group") names.push("channel", "all", "here");
    return names;
  }, [mentionPool, myDisplayName, chatType]);

  // Track the "@query" being typed at the caret; null closes the picker.
  const updateMentionQuery = (value, caret) => {
    const upto = value.slice(0, caret ?? value.length);
    const m = upto.match(/(^|\s)@([\w .-]{0,40})$/);
    setMentionQuery(m ? m[2] : null);
    setMentionIndex(0);
  };

  const pickMention = (person) => {
    if (!person) return;
    const input = composerInputRef.current;
    const caret = input?.selectionStart ?? newMessage.length;
    const upto = newMessage.slice(0, caret);
    const m = upto.match(/(^|\s)@([\w .-]{0,40})$/);
    if (!m) {
      setMentionQuery(null);
      return;
    }
    const start = m.index + m[1].length;
    const inserted = `@${person.name} `;
    setNewMessage(newMessage.slice(0, start) + inserted + newMessage.slice(caret));
    mentionDraftRef.current.set(String(person.name).toLowerCase(), String(person._id));
    setMentionQuery(null);
    // Restore focus + caret right after the inserted mention.
    requestAnimationFrame(() => {
      const pos = start + inserted.length;
      input?.focus();
      input?.setSelectionRange?.(pos, pos);
    });
  };

  // Employee ids actually mentioned in the outgoing text (picker-inserted or
  // hand-typed full names) — only these get the louder "mentioned you" notify.
  const collectMentionIds = (text) => {
    const lower = String(text || "").toLowerCase();
    const ids = new Set();
    mentionPool.forEach((p) => {
      if (p.name && lower.includes(`@${p.name.toLowerCase()}`)) ids.add(String(p._id));
    });
    mentionDraftRef.current.forEach((id, nameLower) => {
      if (lower.includes(`@${nameLower}`)) ids.add(id);
    });
    return [...ids];
  };

  const handleFileChange = (e) => {
    const picked = Array.from(e.target.files);
    if (picked.length) setSelectedFiles((prev) => [...prev, ...picked]);
    e.target.value = ""; // allow re-picking the same file
  };

  // ---- Drag & drop files onto the conversation to attach them ----
  const hasFiles = (e) => Array.from(e.dataTransfer?.types || []).includes("Files");
  const handleDragOver = (e) => {
    if (!hasFiles(e)) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
    if (!dragActive) setDragActive(true);
  };
  const handleDragLeave = (e) => {
    // Only clear when the pointer actually leaves the chat area (not a child element).
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setDragActive(false);
  };
  const handleDrop = (e) => {
    if (!hasFiles(e)) return;
    e.preventDefault();
    setDragActive(false);
    const dropped = Array.from(e.dataTransfer.files || []);
    if (dropped.length) setSelectedFiles((prev) => [...prev, ...dropped]);
  };

  const handleEmojiClick = (emoji) => {
    setNewMessage((prev) => prev + emoji.emoji);
    setShowEmojiPicker(false);
  };

  // Slack/Mattermost-style formatting toolbar. Each action wraps (or unwraps)
  // the current selection in the corresponding Markdown so the message still
  // stores/render as markdown — no WYSIWYG, so @mentions + code highlight stay
  // intact. Line-prefix actions (list/quote) prefix each selected line.
  const applyFormat = (kind) => {
    const input = composerInputRef.current;
    const value = newMessage;
    const start = input?.selectionStart ?? value.length;
    const end = input?.selectionEnd ?? value.length;
    const selected = value.slice(start, end);

    const wrap = (marker, placeholder) => {
      const inner = selected || placeholder;
      // Toggle off if the selection is already wrapped in this marker.
      const already =
        value.slice(start - marker.length, start) === marker &&
        value.slice(end, end + marker.length) === marker;
      if (already) {
        const next = value.slice(0, start - marker.length) + inner + value.slice(end + marker.length);
        setNewMessage(next);
        const pos = start - marker.length;
        requestAnimationFrame(() => { input?.focus(); input?.setSelectionRange?.(pos, pos + inner.length); });
        return;
      }
      const next = value.slice(0, start) + marker + inner + marker + value.slice(end);
      setNewMessage(next);
      const pos = start + marker.length;
      requestAnimationFrame(() => { input?.focus(); input?.setSelectionRange?.(pos, pos + inner.length); });
    };

    const prefixLines = (mk) => {
      const inner = selected || "";
      const lines = (inner || "text").split("\n");
      const numbered = mk === "1. ";
      const out = lines.map((ln, i) => `${numbered ? `${i + 1}. ` : mk}${ln}`).join("\n");
      const next = value.slice(0, start) + out + value.slice(end);
      setNewMessage(next);
      requestAnimationFrame(() => { input?.focus(); input?.setSelectionRange?.(start, start + out.length); });
    };

    switch (kind) {
      case "bold": return wrap("**", "bold text");
      case "italic": return wrap("_", "italic text");
      case "strike": return wrap("~~", "strikethrough");
      case "code": return wrap("`", "code");
      case "codeblock": {
        const inner = selected || "code";
        const block = `\n\`\`\`\n${inner}\n\`\`\`\n`;
        const next = value.slice(0, start) + block + value.slice(end);
        setNewMessage(next);
        const pos = start + 5; // after "\n```\n"
        requestAnimationFrame(() => { input?.focus(); input?.setSelectionRange?.(pos, pos + inner.length); });
        return;
      }
      case "link": {
        const text = selected || "link text";
        const snippet = `[${text}](url)`;
        const next = value.slice(0, start) + snippet + value.slice(end);
        setNewMessage(next);
        // Select the "url" placeholder for quick typing.
        const urlPos = start + text.length + 3;
        requestAnimationFrame(() => { input?.focus(); input?.setSelectionRange?.(urlPos, urlPos + 3); });
        return;
      }
      case "bullet": return prefixLines("- ");
      case "numbered": return prefixLines("1. ");
      case "quote": return prefixLines("> ");
      default: return undefined;
    }
  };

  // Common id fields for the message-mutation endpoints (DM vs channel).
  const msgTargetIds = () =>
    chatType === "group" ? { groupId: receiverId } : { chatId: dmChatId };

  const handleToggleReaction = async (msg, emoji) => {
    setReactionPickerFor(null);
    const mine = (msg.reactions || []).some(
      (r) => String(r.employeeId) === String(userId) && r.emoji === emoji
    );
    const optimistic = mine
      ? (msg.reactions || []).filter((r) => !(String(r.employeeId) === String(userId) && r.emoji === emoji))
      : [...(msg.reactions || []), { employeeId: String(userId), emoji }];
    patchMessage(msg._id, { reactions: optimistic });
    try {
      const token = sessionStorage.getItem("token");
      await fetch(`/api/chat/reactions`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ ...msgTargetIds(), messageId: msg._id, emoji }),
      });
    } catch (_) {
      toast.error("Could not update reaction");
    }
  };

  const startEdit = (msg) => {
    setEditingId(msg._id);
    setEditingText(msg.message || "");
  };

  const saveEdit = async (msg) => {
    const text = editingText.trim();
    if (!text) return;
    setEditingId(null);
    patchMessage(msg._id, { message: text, editedAt: new Date().toISOString() });
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`/api/chat/messages/${msg._id}/edit`, {
        method: "PATCH",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ ...msgTargetIds(), newText: text }),
      });
      if (!res.ok) throw new Error();
    } catch (_) {
      toast.error("Could not edit message");
    }
  };

  const deleteMsg = async (msg) => {
    if (!window.confirm("Delete this message?")) return;
    patchMessage(msg._id, { deletedAt: new Date().toISOString(), message: "", files: [] });
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`/api/chat/messages/${msg._id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify(msgTargetIds()),
      });
      if (!res.ok) throw new Error();
    } catch (_) {
      toast.error("Could not delete message");
    }
  };

  // Group reactions by emoji for the pill row under a bubble.
  const groupedReactions = (msg) => {
    const map = new Map();
    (msg.reactions || []).forEach((r) => {
      const e = map.get(r.emoji) || { emoji: r.emoji, count: 0, mine: false };
      e.count += 1;
      if (String(r.employeeId) === String(userId)) e.mine = true;
      map.set(r.emoji, e);
    });
    return [...map.values()];
  };

  const QUICK_REACTIONS = ["👍", "❤️", "😂", "🎉", "👀", "🙏"];

  // ---- Message search (DMs + channels) ----
  useEffect(() => {
    if (!searchOpen) return;
    const q = searchQuery.trim();
    if (q.length < 2) { setSearchResults([]); return; }
    setSearchLoading(true);
    const handle = setTimeout(async () => {
      try {
        const token = sessionStorage.getItem("token");
        const res = await fetch(`/api/chat/search?q=${encodeURIComponent(q)}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        setSearchResults(Array.isArray(data?.data) ? data.data : []);
      } catch (_) {
        setSearchResults([]);
      } finally {
        setSearchLoading(false);
      }
    }, 300); // debounce
    return () => clearTimeout(handle);
  }, [searchQuery, searchOpen]);

  const openSearchResult = (r) => {
    setSearchOpen(false);
    setSearchQuery("");
    handleSelectChat(r.conversationId, r.kind === "group" ? "group" : "dm");
  };

  const formatTime = (t) =>
    t
      ? new Date(t).toLocaleString([], { hour: "2-digit", minute: "2-digit", hour12: true })
      : "";



  // Order contacts so the most recently active conversations come first;
  // everyone else stays in alphabetical order beneath them.
  const sortedEmployees = React.useMemo(() => {
    return [...employees].sort((a, b) => {
      const ta = recentMap[String(a._id)] ? new Date(recentMap[String(a._id)]).getTime() : 0;
      const tb = recentMap[String(b._id)] ? new Date(recentMap[String(b._id)]).getTime() : 0;
      if (ta !== tb) return tb - ta;
      return (a.name || "").localeCompare(b.name || "");
    });
  }, [employees, recentMap]);

  const sortedGroups = React.useMemo(() => {
    return [...groups].sort((a, b) => {
      const ta = recentMap[String(a._id)]
        ? new Date(recentMap[String(a._id)]).getTime()
        : a.lastMessageAt
          ? new Date(a.lastMessageAt).getTime()
          : 0;
      const tb = recentMap[String(b._id)]
        ? new Date(recentMap[String(b._id)]).getTime()
        : b.lastMessageAt
          ? new Date(b.lastMessageAt).getTime()
          : 0;
      if (ta !== tb) return tb - ta;
      return (a.name || a.groupName || "").localeCompare(b.name || b.groupName || "");
    });
  }, [groups, recentMap]);

  const activeChatName =
    chatType === "group"
      ? groups.find((g) => g._id === receiverId)?.name ||
        groups.find((g) => g._id === receiverId)?.groupName ||
        "Group"
      : employees.find((e) => e._id === receiverId)?.name || "Your colleague";

  const activeChatInitial = activeChatName?.charAt(0)?.toUpperCase() || "?";

  // Presence + custom status for the open DM peer.
  const activePeer = chatType === "dm" ? employees.find((e) => String(e._id) === String(receiverId)) : null;
  const peerEmpId = activePeer?.employeeid || null;
  const peerOnline = peerEmpId ? onlineSet.has(String(peerEmpId)) : false;
  const peerStatus = peerEmpId ? statuses[String(peerEmpId)] : null;
  const myStatus = myEmpId ? statuses[String(myEmpId)] : null;

  const messagesEndRef = useRef(null);
  const messagesBoxRef = useRef(null);

  useEffect(() => {
    // Scroll ONLY the messages container. scrollIntoView also scrolled every
    // scrollable ancestor — including the window — which dragged the chat
    // header up underneath the fixed app bar on phones.
    const box = messagesBoxRef.current;
    if (box) box.scrollTo({ top: box.scrollHeight, behavior: "smooth" });
  }, [messages]);

  // Group messages by date for date separators
  const getDateLabel = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    if (date.toDateString() === today.toDateString()) return "Today";
    if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
    return date.toLocaleDateString("en-GB", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          // Fill exactly the space between the fixed topbar (64) and, on phones,
          // the bottom nav (60). The negative mb cancels AppShell's main pb so
          // the page itself never scrolls — a scrolled window hid the chat
          // header under the fixed app bar.
          height: { xs: "calc(100dvh - 124px)", md: "calc(100vh - 64px)" },
          mb: { xs: -10, sm: -2 },
          bgcolor: "#f5f7fb",
          overflow: "hidden",
        }}
      >
        {/* ====== Sidebar ====== */}
        {/* Phones get a drill-down: the conversation list fills the screen until a
            chat is opened, then hides so the thread can use the full width (the
            thread header gains a back button). Desktop keeps both panes. */}
        <Box
          sx={{
            width: { xs: "100%", md: 300 },
            minWidth: { xs: 0, md: 300 },
            maxWidth: { xs: "100%", md: 300 },
            display: { xs: receiverId ? "none" : "flex", md: "flex" },
            flexDirection: "column",
            borderRight: "1px solid #eef0f6",
            bgcolor: "#fff",
            overflow: "hidden",
            boxShadow: { md: "2px 0 16px rgba(108,80,191,0.06)" },
            zIndex: 1,
          }}
        >
          <Sideboard
            employees={sortedEmployees}
            groups={sortedGroups}
            onSelectChat={handleSelectChat}
            selectedChatId={receiverId}
            dmUnread={unreadMap.dm}
            groupUnread={unreadMap.group}
            dmPreviews={previewMap.dm}
            groupPreviews={previewMap.group}
            canCreateGroup={canCreateGroup}
            onCreateGroup={() => {
              setGroupName("");
              setGroupMembers([]);
              setGroupVisibility("private");
              setGroupDescription("");
              setCreateGroupOpen(true);
            }}
            onBrowseChannels={openBrowseChannels}
            onOpenSearch={() => { setSearchQuery(""); setSearchResults([]); setSearchOpen(true); }}
            onlineSet={onlineSet}
            statuses={statuses}
            myStatus={myStatus}
            onEditStatus={() => { setStatusDraft({ emoji: myStatus?.emoji || "", text: myStatus?.text || "" }); setStatusDialogOpen(true); }}
          />
        </Box>

        {/* ====== Chat Area ====== */}
        <Box
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          sx={{
            flex: 1,
            display: { xs: receiverId ? "flex" : "none", md: "flex" },
            flexDirection: "column",
            overflow: "hidden",
            position: "relative",
            minWidth: 0,
          }}
        >
          {dragActive && receiverId && (
            <Box sx={{
              position: "absolute", inset: 0, zIndex: 30, m: 1,
              display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1,
              bgcolor: "rgba(108,80,191,0.10)", backdropFilter: "blur(2px)",
              border: "2px dashed #6C50BF", borderRadius: "12px", pointerEvents: "none",
            }}>
              <PhotoLibraryOutlinedIcon sx={{ fontSize: 46, color: "#6C50BF" }} />
              <Typography sx={{ fontWeight: 700, color: "#6C50BF" }}>Drop files to attach</Typography>
              <Typography sx={{ fontSize: "0.8rem", color: "rgba(108,80,191,0.6)" }}>Images and files are added to your message</Typography>
            </Box>
          )}
          {receiverId ? (
            <>
              {/* ---- Chat Header ---- */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 3,
                  py: 1.5,
                  bgcolor: "#fff",
                  borderBottom: "1px solid #eef0f6",
                  minHeight: 64,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
                  {/* Mobile drill-down: return to the conversation list */}
                  <IconButton
                    onClick={() => setReceiverId(null)}
                    sx={{ display: { xs: "inline-flex", md: "none" }, ml: -1, color: "#6C50BF" }}
                    aria-label="Back to conversations"
                  >
                    <ArrowBackIcon />
                  </IconButton>
                  <Avatar
                    sx={{
                      width: 42,
                      height: 42,
                      background: "linear-gradient(135deg, #6C50BF, #492ba3)",
                      fontWeight: 700,
                      fontSize: "1rem",
                    }}
                  >
                    {activeChatInitial}
                  </Avatar>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      noWrap
                      sx={{
                        fontWeight: 700,
                        fontSize: "1rem",
                        color: "#1a1a2e",
                        lineHeight: 1.3,
                      }}
                    >
                      {activeChatName}
                    </Typography>
                    <Typography sx={{ fontSize: "0.75rem", color: peerTyping ? "#6C50BF" : "#8b8fa3", fontWeight: 500, display: "flex", alignItems: "center", gap: 0.5 }}>
                      {peerTyping ? (
                        <em>{peerTyping.name} is typing…</em>
                      ) : chatType === "group" ? (
                        <>
                          {activeGroup?.visibility === "public" ? (
                            <PublicIcon sx={{ fontSize: 13 }} />
                          ) : (
                            <LockOutlinedIcon sx={{ fontSize: 13 }} />
                          )}
                          {activeGroup?.visibility === "public" ? "Public channel" : "Private channel"}
                          {activeGroup?.members?.length ? ` · ${activeGroup.members.length} members` : ""}
                        </>
                      ) : (
                        <>
                          <Box component="span" sx={{ width: 8, height: 8, borderRadius: "50%", flexShrink: 0, bgcolor: peerOnline ? "#22c55e" : "#c7cad6", display: "inline-block" }} />
                          {peerOnline ? "Active now" : "Offline"}
                          {peerStatus?.text ? ` · ${peerStatus.emoji ? peerStatus.emoji + " " : ""}${peerStatus.text}` : ""}
                        </>
                      )}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0, mr: { xs: 7, sm: 8 } }}>
                <Tooltip title="Photos & media" arrow>
                  <IconButton
                    onClick={openMedia}
                    aria-label="Photos and media"
                    sx={{ color: "#8b8fa3", "&:hover": { color: "#6C50BF" } }}
                  >
                    <PhotoLibraryOutlinedIcon />
                  </IconButton>
                </Tooltip>
                {chatType === "group" && activeGroup && (
                  <Tooltip title="Channel settings" arrow>
                    <IconButton
                      onClick={openChannelSettings}
                      aria-label="Channel settings"
                      sx={{ color: "#8b8fa3", "&:hover": { color: "#6C50BF" } }}
                    >
                      <SettingsOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                )}
                </Box>
              </Box>

              {/* Pinned messages bar */}
              {messages.some((m) => m.pinnedAt) && (
                <Box
                  onClick={openPinned}
                  sx={{
                    display: "flex", alignItems: "center", gap: 0.75, px: 3, py: 0.75,
                    bgcolor: "#f3f0fb", borderBottom: "1px solid #e7e1f7", cursor: "pointer",
                    color: "#6C50BF", fontSize: "0.78rem", fontWeight: 600,
                    "&:hover": { bgcolor: "#ece6f9" },
                  }}
                >
                  <PushPinIcon sx={{ fontSize: 15 }} />
                  {messages.filter((m) => m.pinnedAt).length} pinned message{messages.filter((m) => m.pinnedAt).length > 1 ? "s" : ""}
                  <Typography component="span" sx={{ ml: "auto", fontSize: "0.72rem", color: "#8b8fa3" }}>View all</Typography>
                </Box>
              )}

              {/* ---- Messages Area ---- */}
              <Box
                ref={messagesBoxRef}
                sx={{
                  flex: 1,
                  overflowY: "auto",
                  overflowX: "hidden",
                  px: { xs: 1.5, md: 3 },
                  py: 2,
                  bgcolor: "#f5f7fb",
                  "&::-webkit-scrollbar": { width: "5px" },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#ccc",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#aaa",
                  },
                }}
              >
                {loading && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      py: 4,
                    }}
                  >
                    <Typography sx={{ color: "#8b8fa3", fontSize: "0.9rem" }}>
                      Loading messages...
                    </Typography>
                  </Box>
                )}
                {error && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      py: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#e53935",
                        fontSize: "0.85rem",
                        bgcolor: "#ffeef0",
                        px: 2,
                        py: 0.8,
                        borderRadius: "8px",
                      }}
                    >
                      {error}
                    </Typography>
                  </Box>
                )}

                {messages.length > 0 ? (
                  <Stack spacing={1}>
                    {messages.map((m, index) => {
                      const isMe = m.senderId === userId;
                      const currentDate = getDateLabel(m.timestamp);
                      const prevDate =
                        index > 0
                          ? getDateLabel(messages[index - 1].timestamp)
                          : null;
                      const showDateSeparator =
                        index === 0 || currentDate !== prevDate;

                      return (
                        <React.Fragment key={m._id || index}>
                          {/* Date Separator */}
                          {showDateSeparator && currentDate && (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                my: 1.5,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "0.7rem",
                                  color: "#8b8fa3",
                                  bgcolor: "#e8ebf0",
                                  px: 2,
                                  py: 0.4,
                                  borderRadius: "12px",
                                  fontWeight: 500,
                                }}
                              >
                                {currentDate}
                              </Typography>
                            </Box>
                          )}

                          {/* System note — centered, Mattermost-style */}
                          {m.isSystem ? (
                            <Box sx={{ display: "flex", justifyContent: "center", my: 0.5 }}>
                              <Typography
                                sx={{
                                  fontSize: "0.74rem",
                                  color: "#8b8fa3",
                                  fontStyle: "italic",
                                  bgcolor: "rgba(139,143,163,0.10)",
                                  px: 1.5,
                                  py: 0.4,
                                  borderRadius: "10px",
                                  textAlign: "center",
                                }}
                              >
                                {m.message}
                              </Typography>
                            </Box>
                          ) : (
                          <>
                          {/* Message Bubble */}
                          <Box
                            data-mid={String(m._id)}
                            sx={{
                              display: "flex",
                              justifyContent: isMe
                                ? "flex-end"
                                : "flex-start",
                              alignItems: "flex-end",
                              gap: 1,
                              borderRadius: "12px",
                              transition: "background-color .3s",
                              bgcolor: highlightId === String(m._id) ? "rgba(108,80,191,0.16)" : "transparent",
                            }}
                          >
                            {/* Other user avatar */}
                            {!isMe && (
                              <Avatar
                                sx={{
                                  width: 30,
                                  height: 30,
                                  background:
                                    "linear-gradient(135deg, #6C50BF, #492ba3)",
                                  fontSize: "0.7rem",
                                  fontWeight: 600,
                                  mb: 0.5,
                                }}
                              >
                                {m.senderName?.charAt(0)?.toUpperCase() || "?"}
                              </Avatar>
                            )}

                            <Box
                              onMouseEnter={() => setHoverMsgId(m._id)}
                              onMouseLeave={() => { setHoverMsgId(null); setReactionPickerFor(null); }}
                              sx={{
                                maxWidth: "65%",
                                minWidth: 80,
                                position: "relative",
                              }}
                            >
                              {/* Hover action bar: react / edit / delete */}
                              {!m.deletedAt && !m.isSystem && editingId !== m._id &&
                                (hoverMsgId === m._id || reactionPickerFor === m._id) && (
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: -14,
                                    [isMe ? "left" : "right"]: 8,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.2,
                                    bgcolor: "#fff",
                                    border: "1px solid #eef0f6",
                                    borderRadius: "10px",
                                    boxShadow: "0 2px 10px rgba(0,0,0,0.10)",
                                    px: 0.3,
                                    zIndex: 5,
                                  }}
                                >
                                  <Tooltip title="Reply" arrow disableInteractive>
                                    <IconButton
                                      size="small"
                                      aria-label="Reply"
                                      onClick={() => startReply(m)}
                                      sx={{ p: 0.4, color: "#8b8fa3", "&:hover": { color: "#6C50BF" } }}
                                    >
                                      <ReplyIcon sx={{ fontSize: 17 }} />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Forward" arrow disableInteractive>
                                    <IconButton
                                      size="small"
                                      aria-label="Forward"
                                      onClick={() => { setForwardMsg(m); setForwardQuery(""); }}
                                      sx={{ p: 0.4, color: "#8b8fa3", "&:hover": { color: "#6C50BF" } }}
                                    >
                                      <ShortcutOutlinedIcon sx={{ fontSize: 17 }} />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="React" arrow disableInteractive>
                                    <IconButton
                                      size="small"
                                      aria-label="Add reaction"
                                      onClick={() => setReactionPickerFor(reactionPickerFor === m._id ? null : m._id)}
                                      sx={{ p: 0.4, color: "#8b8fa3", "&:hover": { color: "#6C50BF" } }}
                                    >
                                      <InsertEmoticonIcon sx={{ fontSize: 17 }} />
                                    </IconButton>
                                  </Tooltip>
                                  {isMe && !m.isWebhook && (
                                    <Tooltip title="Edit" arrow disableInteractive>
                                      <IconButton
                                        size="small"
                                        aria-label="Edit message"
                                        onClick={() => startEdit(m)}
                                        sx={{ p: 0.4, color: "#8b8fa3", "&:hover": { color: "#6C50BF" } }}
                                      >
                                        <EditOutlinedIcon sx={{ fontSize: 16 }} />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                  {(isMe || canDeleteAny) && (
                                    <Tooltip title="Delete" arrow disableInteractive>
                                      <IconButton
                                        size="small"
                                        aria-label="Delete message"
                                        onClick={() => deleteMsg(m)}
                                        sx={{ p: 0.4, color: "#8b8fa3", "&:hover": { color: "#e53935" } }}
                                      >
                                        <DeleteOutlineIcon sx={{ fontSize: 16 }} />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                  <Tooltip title={m.pinnedAt ? "Unpin" : "Pin"} arrow disableInteractive>
                                    <IconButton
                                      size="small"
                                      aria-label={m.pinnedAt ? "Unpin message" : "Pin message"}
                                      onClick={() => togglePin(m)}
                                      sx={{ p: 0.4, color: m.pinnedAt ? "#6C50BF" : "#8b8fa3", "&:hover": { color: "#6C50BF" } }}
                                    >
                                      {m.pinnedAt ? <PushPinIcon sx={{ fontSize: 15 }} /> : <PushPinOutlinedIcon sx={{ fontSize: 15 }} />}
                                    </IconButton>
                                  </Tooltip>
                                  {/* Quick-reaction emoji strip */}
                                  {reactionPickerFor === m._id && (
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.2, ml: 0.3, pl: 0.3, borderLeft: "1px solid #eef0f6" }}>
                                      {QUICK_REACTIONS.map((e) => (
                                        <Box
                                          key={e}
                                          component="span"
                                          role="button"
                                          aria-label={`React ${e}`}
                                          onClick={() => handleToggleReaction(m, e)}
                                          sx={{ cursor: "pointer", fontSize: "1rem", px: 0.3, borderRadius: "6px", "&:hover": { bgcolor: "#f5f7fb" } }}
                                        >
                                          {e}
                                        </Box>
                                      ))}
                                    </Box>
                                  )}
                                </Box>
                              )}
                              <Paper
                                elevation={0}
                                sx={{
                                  px: 2,
                                  py:
                                    m.files?.length > 0 && !m.message
                                      ? 1
                                      : 1.5,
                                  background: isMe
                                    ? "linear-gradient(135deg, #6C50BF 0%, #492ba3 100%)"
                                    : "#fff",
                                  color: isMe ? "#fff" : "#1a1a2e",
                                  borderRadius: isMe
                                    ? "18px 18px 4px 18px"
                                    : "18px 18px 18px 4px",
                                  overflow: "hidden",
                                  boxShadow: isMe
                                    ? "0 2px 12px rgba(108,80,191,0.25)"
                                    : "0 1px 6px rgba(0,0,0,0.06)",
                                }}
                              >
                                {/* Pinned marker */}
                                {m.pinnedAt && !m.deletedAt && (
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.3, mb: 0.4, fontSize: "0.62rem", fontWeight: 700, color: isMe ? "rgba(255,255,255,0.9)" : "#6C50BF" }}>
                                    <PushPinIcon sx={{ fontSize: 11 }} /> Pinned
                                  </Box>
                                )}
                                {/* Reply quote (threaded) */}
                                {m.forwardedFrom?.senderName && !m.deletedAt && (
                                  <Typography sx={{ fontSize: "0.66rem", fontStyle: "italic", display: "flex", alignItems: "center", gap: 0.4, mb: 0.4, color: isMe ? "rgba(255,255,255,0.75)" : "#8b8fa3" }}>
                                    <ShortcutOutlinedIcon sx={{ fontSize: 12 }} /> Forwarded from {m.forwardedFrom.senderName}
                                  </Typography>
                                )}
                                {m.replyToMessageId && !m.deletedAt && (() => {
                                  const parent = msgById(m.replyToMessageId);
                                  const qName = parent
                                    ? (String(parent.senderId) === String(userId) ? "You" : (parent.senderName || "Someone"))
                                    : (m.replyPreview?.senderName || "");
                                  const qText = parent
                                    ? (parent.message || parent.content || "")
                                    : (m.replyPreview?.message || m.replyPreview?.content || "");
                                  return (
                                    <Box onClick={() => scrollToMessage(m.replyToMessageId)} title="Go to replied message"
                                      sx={{ borderLeft: `3px solid ${isMe ? "rgba(255,255,255,0.55)" : "#c9bdf0"}`, pl: 1, mb: 0.6, opacity: 0.92, maxWidth: 260, cursor: "pointer", borderRadius: "4px", "&:hover": { opacity: 1, bgcolor: isMe ? "rgba(255,255,255,0.12)" : "rgba(108,80,191,0.08)" } }}>
                                      <Typography sx={{ fontSize: "0.66rem", fontWeight: 700, color: isMe ? "rgba(255,255,255,0.92)" : "#6C50BF" }} noWrap>
                                        ↩ {qName}
                                      </Typography>
                                      <Typography sx={{ fontSize: "0.72rem", color: isMe ? "rgba(255,255,255,0.82)" : "#8b8fa3" }} noWrap>
                                        {(qText || "").replace(/[#*_`>]/g, "").slice(0, 80) || "message"}
                                      </Typography>
                                    </Box>
                                  );
                                })()}
                                {/* Sender Name */}
                                {!isMe && m.senderName && (
                                  <Typography
                                    sx={{
                                      mb: 0.3,
                                      fontWeight: 700,
                                      fontSize: "0.72rem",
                                      color: "#6C50BF",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.6,
                                    }}
                                  >
                                    {m.senderName}
                                    {m.isWebhook && (
                                      <Box
                                        component="span"
                                        sx={{
                                          fontSize: "0.58rem",
                                          fontWeight: 800,
                                          letterSpacing: "0.04em",
                                          color: "#fff",
                                          bgcolor: "#6C50BF",
                                          borderRadius: "4px",
                                          px: 0.6,
                                          py: 0.1,
                                          lineHeight: 1.4,
                                        }}
                                      >
                                        APP
                                      </Box>
                                    )}
                                  </Typography>
                                )}

                                {/* Deleted placeholder */}
                                {m.deletedAt && (
                                  <Typography
                                    sx={{
                                      fontSize: "0.82rem",
                                      fontStyle: "italic",
                                      color: isMe ? "rgba(255,255,255,0.85)" : "#8b8fa3",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.5,
                                    }}
                                  >
                                    <DeleteOutlineIcon sx={{ fontSize: 15 }} /> This message was deleted
                                  </Typography>
                                )}

                                {/* Inline editor */}
                                {!m.deletedAt && editingId === m._id && (
                                  <Box sx={{ minWidth: 220 }}>
                                    <InputBase
                                      value={editingText}
                                      onChange={(e) => setEditingText(e.target.value)}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); saveEdit(m); }
                                        if (e.key === "Escape") setEditingId(null);
                                      }}
                                      multiline
                                      autoFocus
                                      sx={{
                                        width: "100%",
                                        fontSize: "0.875rem",
                                        color: isMe ? "#fff" : "#1a1a2e",
                                        bgcolor: isMe ? "rgba(255,255,255,0.14)" : "#f5f7fb",
                                        borderRadius: "8px",
                                        px: 1,
                                        py: 0.5,
                                      }}
                                    />
                                    <Box sx={{ display: "flex", gap: 1.5, mt: 0.6 }}>
                                      <Box component="span" role="button" aria-label="Save edit" onClick={() => saveEdit(m)}
                                        sx={{ cursor: "pointer", fontSize: "0.72rem", fontWeight: 700, color: isMe ? "#fff" : "#6C50BF" }}>Save</Box>
                                      <Box component="span" role="button" aria-label="Cancel edit" onClick={() => setEditingId(null)}
                                        sx={{ cursor: "pointer", fontSize: "0.72rem", color: isMe ? "rgba(255,255,255,0.8)" : "#8b8fa3" }}>Cancel</Box>
                                    </Box>
                                  </Box>
                                )}

                                {/* Message Body — markdown, sanitised */}
                                {!m.deletedAt && editingId !== m._id && m.message && (
                                  <Typography
                                    component="div"
                                    variant="body2"
                                    sx={{
                                      fontSize: "0.875rem",
                                      lineHeight: 1.55,
                                      wordBreak: "break-word",
                                      "& p": { m: 0 },
                                      "& p + p": { mt: 0.75 },
                                      "& ul, & ol": { m: 0, pl: 2.5 },
                                      "& blockquote": {
                                        m: 0,
                                        my: 0.5,
                                        pl: 1.25,
                                        borderLeft: "3px solid",
                                        borderColor: isMe ? "rgba(255,255,255,0.5)" : "#c9bdf0",
                                        opacity: 0.9,
                                      },
                                      "& code": {
                                        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                                        fontSize: "0.8em",
                                        bgcolor: isMe ? "rgba(0,0,0,0.22)" : "#eef0f6",
                                        borderRadius: "4px",
                                        px: 0.6,
                                        py: 0.1,
                                      },
                                      // Code blocks stay light in BOTH bubble colours so the
                                      // hljs github palette (built for light bg) is readable.
                                      "& pre": {
                                        m: 0,
                                        my: 0.5,
                                        p: 1.25,
                                        bgcolor: "#f6f8fa",
                                        color: "#24292e",
                                        borderRadius: "8px",
                                        overflowX: "auto",
                                        border: "1px solid",
                                        borderColor: isMe ? "rgba(255,255,255,0.35)" : "#e3e6ee",
                                      },
                                      "& pre code": { bgcolor: "transparent", color: "inherit", p: 0, fontSize: "0.78rem" },
                                      // @mentions
                                      "& .chat-mention": {
                                        color: isMe ? "#fff" : "#6C50BF",
                                        fontWeight: 700,
                                        bgcolor: isMe ? "rgba(255,255,255,0.20)" : "rgba(108,80,191,0.10)",
                                        borderRadius: "4px",
                                        px: 0.4,
                                        py: 0.1,
                                      },
                                      "& .chat-mention[data-me='1']": {
                                        bgcolor: "#ffd54f",
                                        color: "#1a1a2e",
                                      },
                                      "& a": {
                                        color: isMe ? "#fff" : "#6C50BF",
                                        fontWeight: 600,
                                        textDecorationColor: "inherit",
                                      },
                                      "& h1, & h2, & h3, & h4": { m: 0, mt: 0.5, fontSize: "1.02em", lineHeight: 1.4 },
                                      "& table": {
                                        borderCollapse: "collapse",
                                        my: 0.5,
                                        "& th, & td": {
                                          border: "1px solid",
                                          borderColor: isMe ? "rgba(255,255,255,0.4)" : "#dfe2ec",
                                          px: 1,
                                          py: 0.4,
                                          fontSize: "0.8rem",
                                        },
                                      },
                                      "& img": { maxWidth: "100%", borderRadius: "6px", cursor: "pointer" },
                                      "& hr": { border: 0, borderTop: "1px solid", borderColor: isMe ? "rgba(255,255,255,0.4)" : "#e3e6ee", my: 1 },
                                    }}
                                    onClick={handleMessageHtmlClick}
                                    dangerouslySetInnerHTML={{
                                      __html: decorateMentions(
                                        renderMessageHtml(m.message),
                                        mentionNames,
                                        myDisplayName
                                      ),
                                    }}
                                  />
                                )}

                                {/* File Attachments */}
                                {!m.deletedAt && editingId !== m._id && m.files?.map((file, idx) => {
                                  const kind = mediaKind(file);

                                  if (kind === "image") {
                                    return (
                                      <Box
                                        key={idx}
                                        component="img"
                                        src={file}
                                        alt="uploaded"
                                        sx={{
                                          mt: 1,
                                          maxWidth: "100%",
                                          maxHeight: 260,
                                          borderRadius: "12px",
                                          cursor: "pointer",
                                          objectFit: "cover",
                                          display: "block",
                                        }}
                                        onClick={() => openMediaLightbox(file)}
                                      />
                                    );
                                  }
                                  if (kind === "video") {
                                    return (
                                      <Box
                                        key={idx}
                                        onClick={() => openMediaLightbox(file)}
                                        sx={{
                                          mt: 1,
                                          borderRadius: "12px",
                                          overflow: "hidden",
                                          position: "relative",
                                          cursor: "pointer",
                                          maxHeight: 260,
                                          bgcolor: "#111",
                                        }}
                                      >
                                        <Box
                                          component="video"
                                          src={file}
                                          muted
                                          preload="metadata"
                                          sx={{
                                            width: "100%",
                                            maxHeight: 260,
                                            display: "block",
                                            objectFit: "cover",
                                            pointerEvents: "none",
                                          }}
                                        />
                                        <Box
                                          sx={{
                                            position: "absolute",
                                            inset: 0,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            bgcolor: "rgba(0,0,0,0.28)",
                                          }}
                                        >
                                          <PlayCircleOutlineIcon sx={{ fontSize: 56, color: "#fff" }} />
                                        </Box>
                                      </Box>
                                    );
                                  }
                                  const fileName = fileNameFromUrl(file) || "File";
                                  return (
                                    <Box
                                      key={idx}
                                      component="a"
                                      href={file}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      sx={{
                                        mt: 1,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        px: 1.5,
                                        py: 1,
                                        bgcolor: isMe
                                          ? "rgba(255,255,255,0.15)"
                                          : "#f5f7fb",
                                        borderRadius: "10px",
                                        textDecoration: "none",
                                        color: isMe ? "#fff" : "#1a1a2e",
                                        transition: "background 0.15s",
                                        "&:hover": {
                                          bgcolor: isMe
                                            ? "rgba(255,255,255,0.25)"
                                            : "#eef0f6",
                                        },
                                      }}
                                    >
                                      <DescriptionOutlinedIcon
                                        sx={{ fontSize: 20 }}
                                      />
                                      <Typography
                                        sx={{
                                          flex: 1,
                                          fontSize: "0.8rem",
                                          fontWeight: 500,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {fileName}
                                      </Typography>
                                      <DownloadIcon
                                        sx={{ fontSize: 18, opacity: 0.7 }}
                                      />
                                    </Box>
                                  );
                                })}

                                {/* Timestamp */}
                                <Typography
                                  sx={{
                                    display: "block",
                                    mt: 0.5,
                                    fontSize: "0.625rem",
                                    color: isMe
                                      ? "rgba(255,255,255,0.6)"
                                      : "#8b8fa3",
                                    textAlign: isMe ? "right" : "left",
                                  }}
                                >
                                  {formatTime(m.timestamp)}
                                  {m.editedAt && !m.deletedAt ? " · edited" : ""}
                                </Typography>
                              </Paper>

                              {/* Thread: reply count → jump to replies */}
                              {!m.deletedAt && replyCounts[String(m._id)] > 0 && (
                                <Box sx={{ display: "flex", justifyContent: isMe ? "flex-end" : "flex-start", mt: 0.4 }}>
                                  <Box onClick={() => scrollToMessage(firstReplyId(m._id))} title="Jump to replies"
                                    sx={{ display: "inline-flex", alignItems: "center", gap: 0.4, cursor: "pointer", color: "#6C50BF", fontSize: "0.68rem", fontWeight: 700, bgcolor: "rgba(108,80,191,0.08)", px: 0.75, py: 0.25, borderRadius: "10px", "&:hover": { bgcolor: "rgba(108,80,191,0.16)" } }}>
                                    <ReplyIcon sx={{ fontSize: 13, transform: "scaleX(-1)" }} />
                                    {replyCounts[String(m._id)]} {replyCounts[String(m._id)] === 1 ? "reply" : "replies"}
                                  </Box>
                                </Box>
                              )}

                              {/* Reaction pills */}
                              {!m.deletedAt && groupedReactions(m).length > 0 && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 0.5,
                                    mt: 0.5,
                                    justifyContent: isMe ? "flex-end" : "flex-start",
                                  }}
                                >
                                  {groupedReactions(m).map((r) => (
                                    <Box
                                      key={r.emoji}
                                      role="button"
                                      aria-label={`${r.emoji} ${r.count}${r.mine ? " (you reacted)" : ""}`}
                                      onClick={() => handleToggleReaction(m, r.emoji)}
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 0.4,
                                        cursor: "pointer",
                                        px: 0.7,
                                        py: 0.1,
                                        borderRadius: "11px",
                                        fontSize: "0.78rem",
                                        border: "1px solid",
                                        borderColor: r.mine ? "#6C50BF" : "#e3e6ee",
                                        bgcolor: r.mine ? "rgba(108,80,191,0.10)" : "#fff",
                                        userSelect: "none",
                                      }}
                                    >
                                      <span>{r.emoji}</span>
                                      <span style={{ fontWeight: 600, color: r.mine ? "#6C50BF" : "#8b8fa3" }}>{r.count}</span>
                                    </Box>
                                  ))}
                                </Box>
                              )}
                            </Box>
                          </Box>
                          </>
                          )}
                        </React.Fragment>
                      );
                    })}
                    <div ref={messagesEndRef} />
                  </Stack>
                ) : (
                  !loading && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        textAlign: "center",
                        color: "#8b8fa3",
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, rgba(108,80,191,0.12), rgba(118,75,162,0.12))",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 2.5,
                        }}
                      >
                        <ChatBubbleOutlineIcon
                          sx={{ fontSize: 36, color: "#6C50BF" }}
                        />
                      </Box>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "1.1rem",
                          color: "#1a1a2e",
                          mb: 0.5,
                        }}
                      >
                        No messages yet
                      </Typography>
                      <Typography sx={{ fontSize: "0.85rem", maxWidth: 280 }}>
                        Start a conversation by sending a message below
                      </Typography>
                    </Box>
                  )
                )}
              </Box>

              {/* ---- Input Area ---- */}
              <Box
                component="form"
                onSubmit={sendMessage}
                sx={{
                  bgcolor: "#fff",
                  borderTop: "1px solid #eef0f6",
                  position: "relative",
                }}
              >
                {/* Reply preview (composing a threaded reply) */}
                {replyingTo && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, px: 2, pt: 1, pb: 0.5, borderBottom: "1px solid #eef0f6" }}>
                    <ReplyIcon sx={{ fontSize: 16, color: "#6C50BF" }} />
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography sx={{ fontSize: "0.72rem", fontWeight: 700, color: "#6C50BF" }}>
                        Replying to {replyingTo.senderName}
                      </Typography>
                      <Typography sx={{ fontSize: "0.75rem", color: "#8b8fa3" }} noWrap>
                        {replyingTo.text || "message"}
                      </Typography>
                    </Box>
                    <IconButton size="small" onClick={() => setReplyingTo(null)} aria-label="Cancel reply">
                      <CloseIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Box>
                )}
                {/* Selected Files Preview */}
                {selectedFiles.length > 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      px: 2,
                      pt: 1.5,
                      pb: 0.5,
                      flexWrap: "wrap",
                      borderBottom: "1px solid #eef0f6",
                    }}
                  >
                    {selectedFiles.map((file, idx) => {
                      const ext = file.name.split(".").pop().toLowerCase();
                      const isImage = ["jpg", "jpeg", "png", "gif"].includes(
                        ext
                      );
                      return (
                        <Box
                          key={idx}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.8,
                            bgcolor: "#f5f7fb",
                            border: "1px solid #eef0f6",
                            borderRadius: "10px",
                            px: 1.2,
                            py: 0.6,
                            maxWidth: 180,
                          }}
                        >
                          {isImage ? (
                            <Box
                              component="img"
                              src={URL.createObjectURL(file)}
                              alt={file.name}
                              sx={{
                                width: 32,
                                height: 32,
                                objectFit: "cover",
                                borderRadius: "6px",
                              }}
                            />
                          ) : (
                            <DescriptionOutlinedIcon
                              sx={{ fontSize: 20, color: "#6C50BF" }}
                            />
                          )}
                          <Typography
                            sx={{
                              fontSize: "0.75rem",
                              fontWeight: 500,
                              color: "#1a1a2e",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              flex: 1,
                            }}
                          >
                            {file.name}
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() =>
                              setSelectedFiles((prev) =>
                                prev.filter((_, i) => i !== idx)
                              )
                            }
                            sx={{ p: 0.3 }}
                          >
                            <CloseIcon sx={{ fontSize: 14, color: "#8b8fa3" }} />
                          </IconButton>
                        </Box>
                      );
                    })}
                  </Box>
                )}

                {/* Emoji Picker */}
                {showEmojiPicker && (
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: "100%",
                      left: 16,
                      mb: 1,
                      zIndex: 10,
                      boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
                      borderRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    <EmojiPicker
                      onEmojiClick={handleEmojiClick}
                      width={320}
                      height={380}
                    />
                  </Box>
                )}

                {/* Formatting toolbar — wraps the selection in Markdown */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.2,
                    px: 1.5,
                    pt: 1,
                    flexWrap: "wrap",
                    "& .MuiIconButton-root": {
                      color: "#8b8fa3",
                      p: 0.6,
                      borderRadius: "6px",
                      "&:hover": { color: "#6C50BF", bgcolor: "rgba(108,80,191,0.08)" },
                    },
                  }}
                >
                  {[
                    { k: "bold", icon: <FormatBoldIcon sx={{ fontSize: 18 }} />, t: "Bold  (**text**)" },
                    { k: "italic", icon: <FormatItalicIcon sx={{ fontSize: 18 }} />, t: "Italic  (_text_)" },
                    { k: "strike", icon: <StrikethroughSIcon sx={{ fontSize: 18 }} />, t: "Strikethrough  (~~text~~)" },
                    { k: "code", icon: <CodeIcon sx={{ fontSize: 18 }} />, t: "Inline code  (`code`)" },
                    { k: "codeblock", icon: <DataObjectIcon sx={{ fontSize: 17 }} />, t: "Code block  (``` ```)" },
                    { k: "link", icon: <LinkIcon sx={{ fontSize: 18 }} />, t: "Link  ([text](url))" },
                    { k: "bullet", icon: <FormatListBulletedIcon sx={{ fontSize: 18 }} />, t: "Bulleted list" },
                    { k: "numbered", icon: <FormatListNumberedIcon sx={{ fontSize: 18 }} />, t: "Numbered list" },
                    { k: "quote", icon: <FormatQuoteIcon sx={{ fontSize: 18 }} />, t: "Quote  (> )" },
                  ].map((b) => (
                    <Tooltip key={b.k} title={b.t} arrow disableInteractive>
                      <IconButton
                        size="small"
                        aria-label={b.t}
                        // preventDefault keeps the composer's selection/focus
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => applyFormat(b.k)}
                      >
                        {b.icon}
                      </IconButton>
                    </Tooltip>
                  ))}
                </Box>

                {/* Input Row */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    px: 1.5,
                    py: 1.2,
                  }}
                >
                  {/* Emoji Toggle */}
                  <IconButton
                    onClick={() => setShowEmojiPicker((prev) => !prev)}
                    sx={{
                      color: showEmojiPicker ? "#6C50BF" : "#8b8fa3",
                      "&:hover": { color: "#6C50BF" },
                    }}
                  >
                    <InsertEmoticonIcon />
                  </IconButton>

                  {/* Attach File */}
                  <IconButton
                    component="label"
                    sx={{
                      color: "#8b8fa3",
                      "&:hover": { color: "#6C50BF" },
                    }}
                  >
                    <AttachFileIcon sx={{ transform: "rotate(45deg)" }} />
                    <input
                      type="file"
                      multiple
                      hidden
                      onChange={handleFileChange}
                    />
                  </IconButton>

                  {/* Text Input */}
                  <Box
                    sx={{
                      flex: 1,
                      bgcolor: "#f5f7fb",
                      borderRadius: "24px",
                      px: 2,
                      py: 0.8,
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    {/* @mention picker — floats above the composer */}
                    {mentionQuery != null && mentionCandidates.length > 0 && (
                      <Paper
                        elevation={4}
                        sx={{
                          position: "absolute",
                          bottom: "calc(100% + 10px)",
                          left: 0,
                          width: 300,
                          maxWidth: "90vw",
                          maxHeight: 250,
                          overflowY: "auto",
                          borderRadius: 2.5,
                          border: "1px solid #eef0f6",
                          zIndex: 30,
                        }}
                      >
                        <Typography sx={{ px: 1.5, pt: 1, pb: 0.4, fontSize: "0.68rem", fontWeight: 700, color: "#8b8fa3", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                          Mention a member
                        </Typography>
                        {mentionCandidates.map((p, i) => (
                          <Box
                            key={p._id}
                            // mousedown (not click) so the composer doesn't blur first
                            onMouseDown={(ev) => {
                              ev.preventDefault();
                              pickMention(p);
                            }}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1.2,
                              px: 1.5,
                              py: 0.9,
                              cursor: "pointer",
                              bgcolor: i === mentionIndex ? "rgba(108,80,191,0.10)" : "transparent",
                              "&:hover": { bgcolor: "rgba(108,80,191,0.10)" },
                            }}
                          >
                            <Avatar sx={{ width: 26, height: 26, fontSize: "0.68rem", fontWeight: 700, background: "linear-gradient(135deg, #6C50BF, #492ba3)" }}>
                              {p.name?.charAt(0)?.toUpperCase() || "?"}
                            </Avatar>
                            <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, color: "#1a1a2e" }} noWrap>
                              {p.name}
                            </Typography>
                            {p.designation && (
                              <Typography sx={{ fontSize: "0.72rem", color: "#8b8fa3", ml: "auto" }} noWrap>
                                {p.designation}
                              </Typography>
                            )}
                          </Box>
                        ))}
                      </Paper>
                    )}
                    <InputBase
                      placeholder="Type a message — Markdown + @mentions (**bold**, `code`, ``` blocks…)"
                      value={newMessage}
                      inputRef={composerInputRef}
                      onChange={(e) => {
                        setNewMessage(e.target.value);
                        updateMentionQuery(e.target.value, e.target.selectionStart);
                        emitTyping();
                      }}
                      onKeyDown={(e) => {
                        // Picker open: arrows navigate, Enter/Tab select, Esc closes.
                        if (mentionQuery != null && mentionCandidates.length > 0) {
                          if (e.key === "ArrowDown") {
                            e.preventDefault();
                            setMentionIndex((i) => (i + 1) % mentionCandidates.length);
                            return;
                          }
                          if (e.key === "ArrowUp") {
                            e.preventDefault();
                            setMentionIndex((i) => (i - 1 + mentionCandidates.length) % mentionCandidates.length);
                            return;
                          }
                          if (e.key === "Enter" || e.key === "Tab") {
                            e.preventDefault();
                            pickMention(mentionCandidates[mentionIndex]);
                            return;
                          }
                          if (e.key === "Escape") {
                            setMentionQuery(null);
                            return;
                          }
                        }
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          if (newMessage.trim() || selectedFiles.length > 0) {
                            sendMessage(e);
                          }
                        }
                      }}
                      multiline
                      maxRows={4}
                      sx={{
                        flex: 1,
                        fontSize: "0.9rem",
                        color: "#1a1a2e",
                        "& ::placeholder": {
                          color: "#8b8fa3",
                          opacity: 1,
                        },
                      }}
                    />
                  </Box>

                  {/* Send Button */}
                  <IconButton
                    type="submit"
                    disabled={
                      loading ||
                      (!newMessage.trim() && selectedFiles.length === 0)
                    }
                    sx={{
                      width: 44,
                      height: 44,
                      background:
                        !newMessage.trim() && selectedFiles.length === 0
                          ? "#e0e3eb"
                          : "linear-gradient(135deg, #6C50BF, #492ba3)",
                      color: "#fff",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #5d43a8, #3d2387)",
                      },
                      "&.Mui-disabled": {
                        color: "#b0b5c3",
                        background: "#e0e3eb",
                      },
                      transition: "all 0.2s ease",
                      boxShadow:
                        newMessage.trim() || selectedFiles.length > 0
                          ? "0 3px 12px rgba(108,80,191,0.35)"
                          : "none",
                    }}
                  >
                    <SendIcon sx={{ fontSize: 20, ml: 0.3 }} />
                  </IconButton>
                </Box>
              </Box>
            </>
          ) : (
            /* ---- Empty State (no chat selected) ---- */
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#f5f7fb",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  background:
                    "linear-gradient(135deg, rgba(108,80,191,0.1), rgba(118,75,162,0.1))",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 3,
                }}
              >
                <ChatBubbleOutlineIcon
                  sx={{ fontSize: 52, color: "#6C50BF" }}
                />
              </Box>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "1.4rem",
                  color: "#1a1a2e",
                  mb: 1,
                }}
              >
                Welcome to HRMS Chat
              </Typography>
              <Typography
                sx={{ fontSize: "0.95rem", color: "#8b8fa3", maxWidth: 360 }}
              >
                Select a conversation from the sidebar to start messaging your
                team
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* ====== Create Group Dialog ====== */}
      <Dialog
        open={createGroupOpen}
        onClose={() => setCreateGroupOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ fontWeight: 700 }}>Create a new channel</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2} sx={{ mt: 0.5 }}>
            <TextField
              label="Channel name"
              fullWidth
              autoFocus
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
            />
            <TextField
              select
              label="Visibility"
              value={groupVisibility}
              onChange={(e) => setGroupVisibility(e.target.value)}
              helperText={
                groupVisibility === "public"
                  ? "Anyone in the company can find and join this channel."
                  : "Only invited members can see this channel."
              }
            >
              <MenuItem value="private">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <LockOutlinedIcon sx={{ fontSize: 16 }} /> Private
                </Box>
              </MenuItem>
              <MenuItem value="public">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <PublicIcon sx={{ fontSize: 16 }} /> Public
                </Box>
              </MenuItem>
            </TextField>
            <TextField
              label="Description (optional)"
              fullWidth
              multiline
              minRows={2}
              value={groupDescription}
              onChange={(e) => setGroupDescription(e.target.value)}
              inputProps={{ maxLength: 300 }}
            />
            <Autocomplete
              multiple
              options={sortedEmployees.filter((e) => !String(e.employeeid || "").startsWith("BOT-"))}
              value={groupMembers}
              onChange={(_e, val) => setGroupMembers(val)}
              getOptionLabel={(o) =>
                `${o.name || "Unknown"}${o.employeeid ? ` (${o.employeeid})` : ""}`
              }
              isOptionEqualToValue={(o, v) => String(o._id) === String(v._id)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Add members"
                  placeholder="Select employees"
                />
              )}
            />
            <Typography sx={{ fontSize: "0.78rem", color: "#8b8fa3" }}>
              {groupVisibility === "public"
                ? "The channel starts with the members you add — anyone else can join it from Browse channels."
                : "Only the members you add (plus you) will see and chat in this channel."}
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCreateGroupOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleCreateGroup}
            disabled={!groupName.trim() || groupMembers.length === 0}
          >
            Create channel
          </Button>
        </DialogActions>
      </Dialog>

      {/* ====== Browse Public Channels Dialog ====== */}
      <Dialog open={browseOpen} onClose={() => setBrowseOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 700, display: "flex", alignItems: "center", gap: 1 }}>
          <PublicIcon sx={{ color: "#6C50BF" }} /> Browse public channels
        </DialogTitle>
        <DialogContent dividers>
          {browseLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={28} sx={{ color: "#6C50BF" }} />
            </Box>
          ) : publicChannels.length === 0 ? (
            <Typography sx={{ py: 3, textAlign: "center", color: "#8b8fa3", fontSize: "0.9rem" }}>
              No public channels yet.
              {canCreateGroup ? " Create one and set its visibility to Public." : ""}
            </Typography>
          ) : (
            <List disablePadding>
              {publicChannels.map((ch) => (
                <ListItem
                  key={ch._id}
                  divider
                  secondaryAction={
                    ch.isMember ? (
                      <Button
                        size="small"
                        onClick={() => {
                          setBrowseOpen(false);
                          handleSelectChat(ch._id, "group");
                        }}
                      >
                        Open
                      </Button>
                    ) : (
                      <Button
                        size="small"
                        variant="contained"
                        disabled={joiningId === ch._id}
                        onClick={() => handleJoinChannel(ch._id)}
                      >
                        {joiningId === ch._id ? "Joining…" : "Join"}
                      </Button>
                    )
                  }
                >
                  <ListItemText
                    primary={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography sx={{ fontWeight: 600, fontSize: "0.92rem" }}>
                          # {ch.name}
                        </Typography>
                        <Chip
                          label={`${ch.memberCount || 0} members`}
                          size="small"
                          sx={{ height: 18, fontSize: "0.65rem" }}
                        />
                      </Box>
                    }
                    secondary={ch.description || null}
                    secondaryTypographyProps={{ fontSize: "0.78rem", noWrap: true }}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBrowseOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* ====== Channel Settings Dialog ====== */}
      <Dialog open={settingsOpen} onClose={() => setSettingsOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 700 }}>
          {activeGroup?.name || "Channel"} — settings
        </DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2.5} sx={{ mt: 0.5 }}>
            {/* Visibility + description (admin editable, others read-only) */}
            {isChannelAdmin ? (
              <>
                <TextField
                  select
                  label="Visibility"
                  value={editVisibility}
                  onChange={(e) => setEditVisibility(e.target.value)}
                  helperText={
                    editVisibility === "public"
                      ? "Anyone in the company can find and join this channel."
                      : "Only invited members can see this channel."
                  }
                >
                  <MenuItem value="private">Private</MenuItem>
                  <MenuItem value="public">Public</MenuItem>
                </TextField>
                <TextField
                  label="Description"
                  fullWidth
                  multiline
                  minRows={2}
                  value={editDescription}
                  onChange={(e) => setEditDescription(e.target.value)}
                  inputProps={{ maxLength: 300 }}
                />
                <Box>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleSaveChannelSettings}
                    disabled={settingsSaving}
                  >
                    {settingsSaving ? "Saving…" : "Save channel details"}
                  </Button>
                </Box>
              </>
            ) : (
              <Box>
                <Typography sx={{ fontSize: "0.8rem", color: "#8b8fa3", display: "flex", alignItems: "center", gap: 0.5 }}>
                  {activeGroup?.visibility === "public" ? <PublicIcon sx={{ fontSize: 14 }} /> : <LockOutlinedIcon sx={{ fontSize: 14 }} />}
                  {activeGroup?.visibility === "public" ? "Public channel" : "Private channel"}
                </Typography>
                {activeGroup?.description && (
                  <Typography sx={{ fontSize: "0.85rem", mt: 0.5 }}>{activeGroup.description}</Typography>
                )}
              </Box>
            )}

            <Divider />

            {/* Members */}
            <Box>
              <Typography sx={{ fontWeight: 700, fontSize: "0.85rem", mb: 1 }}>
                Members ({channelMembers.length})
              </Typography>
              <List dense disablePadding sx={{ maxHeight: 200, overflowY: "auto" }}>
                {channelMembers.map((mem) => (
                  <ListItem
                    key={mem._id}
                    disableGutters
                    secondaryAction={
                      isChannelAdmin && !mem.isMe ? (
                        <Tooltip title="Remove from channel" arrow>
                          <IconButton
                            edge="end"
                            size="small"
                            aria-label={`Remove ${mem.name}`}
                            onClick={() => handleRemoveMember(mem._id)}
                          >
                            <PersonRemoveOutlinedIcon sx={{ fontSize: 18, color: "#e53935" }} />
                          </IconButton>
                        </Tooltip>
                      ) : null
                    }
                  >
                    <Avatar sx={{ width: 26, height: 26, mr: 1.2, fontSize: "0.7rem", background: "linear-gradient(135deg, #6C50BF, #492ba3)" }}>
                      {mem.name?.charAt(0)?.toUpperCase() || "?"}
                    </Avatar>
                    <ListItemText
                      primary={mem.name + (String(activeGroup?.adminId) === String(mem._id) ? "  ·  admin" : "")}
                      secondary={mem.designation || null}
                      primaryTypographyProps={{ fontSize: "0.85rem" }}
                      secondaryTypographyProps={{ fontSize: "0.72rem" }}
                    />
                  </ListItem>
                ))}
              </List>
              {/* Mattermost model: ANY member can add people to the channel
                  (public or private). Only the channel admin can remove. */}
              <Stack direction="row" spacing={1} sx={{ mt: 1.5 }} alignItems="center">
                <Autocomplete
                  multiple
                  size="small"
                  sx={{ flex: 1 }}
                  options={nonMemberEmployees}
                  value={addMemberSel}
                  onChange={(_e, val) => setAddMemberSel(val)}
                  getOptionLabel={(o) => `${o.name || "Unknown"}${o.employeeid ? ` (${o.employeeid})` : ""}`}
                  isOptionEqualToValue={(o, v) => String(o._id) === String(v._id)}
                  renderInput={(params) => (
                    <TextField {...params} label="Add members" placeholder="Search people" />
                  )}
                />
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleAddMembers}
                  disabled={addMemberSel.length === 0}
                >
                  Add
                </Button>
              </Stack>
              {!isChannelAdmin && (
                <Typography sx={{ mt: 0.75, fontSize: "0.72rem", color: "#8b8fa3" }}>
                  Any member can add people. Only the channel admin can remove members.
                </Typography>
              )}
            </Box>

            {/* Incoming webhooks — admin only */}
            {isChannelAdmin && (
              <>
                <Divider />
                <Box>
                  <Typography sx={{ fontWeight: 700, fontSize: "0.85rem" }}>
                    Incoming webhooks
                  </Typography>
                  <Typography sx={{ fontSize: "0.75rem", color: "#8b8fa3", mb: 1 }}>
                    POST JSON like {"{\"text\": \"**Build passed** ✅\"}"} to the URL and it appears in this
                    channel. Anyone with the URL can post — treat it like a password.
                  </Typography>
                  {webhooks.map((w) => (
                    <Stack
                      key={w.token}
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      sx={{ mb: 0.8, bgcolor: "#f5f7fb", borderRadius: 2, px: 1.2, py: 0.6 }}
                    >
                      <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography sx={{ fontSize: "0.82rem", fontWeight: 600 }}>{w.name}</Typography>
                        <Typography noWrap sx={{ fontSize: "0.7rem", color: "#8b8fa3", fontFamily: "ui-monospace, Menlo, monospace" }}>
                          {webhookUrl(w)}
                        </Typography>
                      </Box>
                      <Tooltip title="Copy URL" arrow>
                        <IconButton size="small" onClick={() => copyWebhookUrl(w)} aria-label={`Copy ${w.name} webhook URL`}>
                          <ContentCopyIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Revoke webhook" arrow>
                        <IconButton size="small" onClick={() => handleRevokeWebhook(w.token)} aria-label={`Revoke ${w.name} webhook`}>
                          <DeleteOutlineIcon sx={{ fontSize: 17, color: "#e53935" }} />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  ))}
                  <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                    <TextField
                      size="small"
                      label="New webhook name"
                      placeholder="e.g. CI Bot"
                      value={newWebhookName}
                      onChange={(e) => setNewWebhookName(e.target.value)}
                      sx={{ flex: 1 }}
                    />
                    <Button variant="outlined" size="small" onClick={handleCreateWebhook} disabled={!newWebhookName.trim()}>
                      Create
                    </Button>
                  </Stack>
                </Box>
              </>
            )}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          {!isChannelAdmin ? (
            <Button color="error" startIcon={<LogoutOutlinedIcon />} onClick={handleLeaveChannel}>
              Leave channel
            </Button>
          ) : (
            <Typography sx={{ fontSize: "0.72rem", color: "#8b8fa3", pl: 1 }}>
              Channel admins can't leave their own channel.
            </Typography>
          )}
          <Button onClick={() => setSettingsOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* ====== Message Search Dialog ====== */}
      <Dialog open={searchOpen} onClose={() => setSearchOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>Search messages</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "flex", alignItems: "center", bgcolor: "#f5f7fb", borderRadius: "10px", px: 1.5, py: 0.5, mb: 1.5 }}>
            <SearchIcon sx={{ color: "#8b8fa3", fontSize: 20, mr: 1 }} />
            <InputBase
              autoFocus
              placeholder="Search your messages and channels…"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ flex: 1, fontSize: "0.9rem" }}
            />
          </Box>
          {searchLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
              <CircularProgress size={24} sx={{ color: "#6C50BF" }} />
            </Box>
          ) : searchQuery.trim().length < 2 ? (
            <Typography sx={{ py: 3, textAlign: "center", color: "#8b8fa3", fontSize: "0.85rem" }}>
              Type at least 2 characters to search.
            </Typography>
          ) : searchResults.length === 0 ? (
            <Typography sx={{ py: 3, textAlign: "center", color: "#8b8fa3", fontSize: "0.85rem" }}>
              No messages found for “{searchQuery.trim()}”.
            </Typography>
          ) : (
            <List disablePadding sx={{ maxHeight: 380, overflowY: "auto" }}>
              {searchResults.map((r) => (
                <ListItem
                  key={r.messageId}
                  button
                  divider
                  onClick={() => openSearchResult(r)}
                  sx={{ borderRadius: 1.5 }}
                >
                  <Avatar sx={{ width: 30, height: 30, mr: 1.4, fontSize: "0.72rem", background: "linear-gradient(135deg, #6C50BF, #492ba3)" }}>
                    {r.kind === "group" ? "#" : (r.title?.charAt(0)?.toUpperCase() || "?")}
                  </Avatar>
                  <ListItemText
                    primary={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                        <Typography sx={{ fontWeight: 600, fontSize: "0.85rem" }} noWrap>
                          {r.kind === "group" ? `# ${r.title}` : r.title}
                        </Typography>
                        <Typography sx={{ fontSize: "0.68rem", color: "#8b8fa3", ml: "auto", flexShrink: 0 }}>
                          {r.at ? new Date(r.at).toLocaleDateString("en-GB") : ""}
                        </Typography>
                      </Box>
                    }
                    secondary={r.snippet}
                    secondaryTypographyProps={{ fontSize: "0.78rem", noWrap: true }}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSearchOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* ====== My Custom Status Dialog ====== */}
      <Dialog open={statusDialogOpen} onClose={() => setStatusDialogOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle sx={{ fontWeight: 700 }}>Set a status</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <TextField
              value={statusDraft.emoji}
              onChange={(e) => setStatusDraft((s) => ({ ...s, emoji: e.target.value.slice(0, 4) }))}
              placeholder="😀"
              sx={{ width: 64 }}
              inputProps={{ style: { textAlign: "center", fontSize: 20 } }}
            />
            <TextField
              fullWidth
              autoFocus
              value={statusDraft.text}
              onChange={(e) => setStatusDraft((s) => ({ ...s, text: e.target.value.slice(0, 100) }))}
              placeholder="What's your status?"
              onKeyDown={(e) => { if (e.key === "Enter") saveStatus(); }}
            />
          </Box>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {[
              { emoji: "💻", text: "Working" },
              { emoji: "📅", text: "In a meeting" },
              { emoji: "🍽️", text: "Lunch" },
              { emoji: "🏠", text: "Working remotely" },
              { emoji: "🎯", text: "Focusing" },
              { emoji: "🌴", text: "On leave" },
              { emoji: "🤒", text: "Out sick" },
            ].map((p) => (
              <Chip key={p.text} label={`${p.emoji} ${p.text}`} variant="outlined"
                onClick={() => setStatusDraft({ emoji: p.emoji, text: p.text })} sx={{ cursor: "pointer" }} />
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <Button color="error" onClick={() => setStatusDraft({ emoji: "", text: "" })}>Clear</Button>
          <Box>
            <Button onClick={() => setStatusDialogOpen(false)}>Cancel</Button>
            <Button variant="contained" onClick={saveStatus} disabled={statusSaving}>Save</Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* ====== Pinned Messages Dialog ====== */}
      <Dialog open={pinnedOpen} onClose={() => setPinnedOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 700, display: "flex", alignItems: "center", gap: 1 }}>
          <PushPinIcon sx={{ fontSize: 20, color: "#6C50BF" }} /> Pinned messages
        </DialogTitle>
        <DialogContent dividers>
          {pinnedList.length === 0 ? (
            <Typography sx={{ color: "#8b8fa3", textAlign: "center", py: 3 }}>No pinned messages yet.</Typography>
          ) : (
            pinnedList.map((p) => {
              const body = p.content ?? p.message ?? "";
              const who = p.senderName || (String(p.senderId) === String(userId) ? "You" : (employees.find((e) => String(e._id) === String(p.senderId))?.name || "Someone"));
              const when = p.createdAt || p.timestamp;
              return (
                <Box key={p._id} sx={{ p: 1.25, mb: 1, borderRadius: "10px", bgcolor: "#f5f7fb", border: "1px solid #eef0f6" }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.3 }}>
                    <Typography sx={{ fontSize: "0.75rem", fontWeight: 700, color: "#6C50BF" }}>{who}</Typography>
                    <Typography sx={{ fontSize: "0.68rem", color: "#8b8fa3" }}>{when ? new Date(when).toLocaleString() : ""}</Typography>
                  </Box>
                  <Typography sx={{ fontSize: "0.85rem", color: "#1a1a2e", wordBreak: "break-word" }}>
                    {(body || "").replace(/[#*_`>]/g, "").slice(0, 400) || "📎 Attachment"}
                  </Typography>
                </Box>
              );
            })
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPinnedOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Photos & media gallery */}
      <Dialog open={mediaOpen} onClose={() => setMediaOpen(false)} fullWidth maxWidth="md">
        <DialogTitle sx={{ fontWeight: 700, display: "flex", alignItems: "center", gap: 1 }}>
          <PhotoLibraryOutlinedIcon sx={{ fontSize: 20, color: "#6C50BF" }} /> Photos &amp; media
          {mediaList.length > 0 && <Typography component="span" sx={{ fontSize: "0.8rem", color: "#8b8fa3", fontWeight: 500 }}>· {mediaList.length}</Typography>}
        </DialogTitle>
        <DialogContent dividers>
          {mediaLoading ? (
            <Typography sx={{ color: "#8b8fa3", textAlign: "center", py: 4 }}>Loading…</Typography>
          ) : mediaList.length === 0 ? (
            <Typography sx={{ color: "#8b8fa3", textAlign: "center", py: 3 }}>No images or videos shared in this conversation yet.</Typography>
          ) : (
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(110px, 1fr))", gap: 1 }}>
              {(() => {
                const galleryItems = mediaList
                  .map((row) => ({ url: row.url, kind: mediaKind(row.url) || "image", name: fileNameFromUrl(row.url) }))
                  .filter((row) => row.kind);
                return mediaList.map((m, i) => {
                const kind = mediaKind(m.url) || "image";
                return (
                  <Box
                    key={`${m.messageId}-${i}`}
                    onClick={() => openMediaLightbox(m.url, galleryItems)}
                    title={`${m.senderName || ""}${m.at ? " · " + new Date(m.at).toLocaleString() : ""}`}
                    sx={{ display: "block", position: "relative", cursor: "pointer" }}
                  >
                    {kind === "video" ? (
                      <>
                        <Box
                          component="video"
                          src={m.url}
                          muted
                          preload="metadata"
                          sx={{ width: "100%", aspectRatio: "1 / 1", objectFit: "cover", borderRadius: "8px", border: "1px solid #eef0f6", display: "block", pointerEvents: "none" }}
                        />
                        <Box sx={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "rgba(0,0,0,0.28)", borderRadius: "8px" }}>
                          <PlayCircleOutlineIcon sx={{ fontSize: 36, color: "#fff" }} />
                        </Box>
                      </>
                    ) : (
                      <Box component="img" src={m.url} alt={m.senderName || "shared image"} loading="lazy"
                        sx={{ width: "100%", aspectRatio: "1 / 1", objectFit: "cover", borderRadius: "8px", border: "1px solid #eef0f6", display: "block", transition: "transform .12s", "&:hover": { transform: "scale(1.03)" } }} />
                    )}
                  </Box>
                );
                });
              })()}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setMediaOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <ChatMediaLightbox
        items={lightbox?.items || []}
        index={lightbox?.index || 0}
        onClose={() => setLightbox(null)}
        onIndexChange={(next) => setLightbox((prev) => (prev ? { ...prev, index: next } : prev))}
      />

      {/* Forward-message target picker */}
      <Dialog open={!!forwardMsg} onClose={() => { setForwardMsg(null); setForwardQuery(""); }} fullWidth maxWidth="xs">
        <DialogTitle sx={{ fontWeight: 700, display: "flex", alignItems: "center", gap: 1 }}>
          <ShortcutOutlinedIcon sx={{ fontSize: 20, color: "#6C50BF" }} /> Forward message
        </DialogTitle>
        <DialogContent dividers sx={{ p: 1.5 }}>
          {forwardMsg && (
            <Box sx={{ borderLeft: "3px solid #c9bdf0", pl: 1, mb: 1.5, py: 0.25 }}>
              <Typography sx={{ fontSize: "0.72rem", color: "#8b8fa3" }} noWrap>
                {(forwardMsg.message || forwardMsg.content || "").replace(/[#*_`>]/g, "").slice(0, 90) ||
                  `📎 ${(forwardMsg.files || []).length} attachment${(forwardMsg.files || []).length === 1 ? "" : "s"}`}
              </Typography>
            </Box>
          )}
          <TextField
            fullWidth size="small" autoFocus placeholder="Search people or channels…"
            value={forwardQuery} onChange={(e) => setForwardQuery(e.target.value)} sx={{ mb: 1 }}
          />
          <Box sx={{ maxHeight: 320, overflowY: "auto" }}>
            {(() => {
              const q = forwardQuery.trim().toLowerCase();
              const chans = groups
                .filter((g) => !q || (g.name || "").toLowerCase().includes(q))
                .slice(0, 12)
                .map((g) => ({ id: String(g._id), name: g.name, type: "group" }));
              const people = humanEmployees
                .filter((e) => !q || (e.name || "").toLowerCase().includes(q))
                .slice(0, 12)
                .map((e) => ({ id: String(e._id), name: e.name, type: "dm" }));
              const rows = [...chans, ...people];
              if (rows.length === 0) {
                return <Typography sx={{ color: "#8b8fa3", textAlign: "center", py: 3, fontSize: "0.85rem" }}>No matches</Typography>;
              }
              return rows.map((t) => (
                <Box
                  key={`${t.type}-${t.id}`}
                  onClick={() => !forwardBusy && forwardTo(t)}
                  sx={{
                    display: "flex", alignItems: "center", gap: 1.25, px: 1, py: 0.75, borderRadius: "8px",
                    cursor: forwardBusy ? "default" : "pointer", opacity: forwardBusy && forwardBusy !== t.id ? 0.5 : 1,
                    "&:hover": { bgcolor: "rgba(108,80,191,0.08)" },
                  }}
                >
                  <Avatar sx={{ width: 30, height: 30, fontSize: 13, bgcolor: t.type === "group" ? "#EDE8FA" : "#E6F6F4", color: t.type === "group" ? "#6C50BF" : "#2fa294" }}>
                    {t.type === "group" ? "#" : (t.name || "?").slice(0, 1).toUpperCase()}
                  </Avatar>
                  <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, flex: 1 }} noWrap>{t.name}</Typography>
                  {forwardBusy === t.id
                    ? <Typography sx={{ fontSize: "0.7rem", color: "#8b8fa3" }}>Sending…</Typography>
                    : <ShortcutOutlinedIcon sx={{ fontSize: 15, color: "#c3c7d4" }} />}
                </Box>
              ));
            })()}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setForwardMsg(null); setForwardQuery(""); }}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ChatBoard;